import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormBuilder, FormGroup, FormArray, FormControl, Validators, ValidatorFn } from '@angular/forms';
import { HttpParams, HttpClient, HttpHeaders } from '@angular/common/http';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker/ngx-bootstrap-datepicker';
import { BusinessDayService } from '../../services/business-day.service';
import { SWAlertService } from '../../services/swalert.service';
import Swal from 'sweetalert2';
import { Subject } from 'rxjs/internal/Subject';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead/typeahead-match.class';
import { Router } from '@angular/router';
import { TSFuntionService } from '../../services/ts-funtion.service';
import { async } from '@angular/core/testing';
import { promise } from 'protractor';
import * as _ from 'lodash';

declare var Uploadfiles, Clearuploadfile, Extension, _Path, SetData: any, Accept: any;

declare var ArrFile: any[];

@Component({
  selector: 'app-clearadvance',
  templateUrl: './clearadvance.component.html',
  styleUrls: ['./clearadvance.component.css']
})

export class ClearadvanceComponent implements OnInit {

  constructor(
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private BusinessDay: BusinessDayService,
    private swal: SWAlertService,
    private System: TSFuntionService,
    private router: Router
  ) { }

  PRMS = true;
  currentDate = new Date();

  //#region Reactive From
  InputFrom: FormGroup;//สร้างกลุ่ม Object Data
  get _InputFrom() { return this.InputFrom.controls; }//ประกาศเพื่อใช้เรียกไปยัง From หน้าบ้าน
  get ArrGL() { return this._InputFrom.ArrGL as FormArray; }//Dynamic
  //#endregion

  isReject: boolean = false;
  //#region DataSet Control
  sRequestID = "";
  _RequestType = [];
  _VatType = [];
  _WithholdingTax = [];
  _Currency = [];
  _ArrEmployee = [];
  _ArrCopyReqData = [];
  _ArrAdvanceData = [];
  _ArrEmployeeData = [];
  _ArrVendorData = [];
  _ArrVendorOneTimeData = [];
  _ArrVendorGL = [];
  _ArrVendorCosCentor = [];
  _ArrVendorIO = [];
  _ArrVendor = [];
  _ArrVendorInvoice = [];

  //#region VendorOneTime
  IsVendorOneTime = false;
  _ArrCountry = [];
  _ArrProvince = [];
  _ArrAmphur = [];
  _ArrTumbon = [];
  ArrTransactionHistory: any;
  IsNoDataTrans: boolean = true;

  clicked: boolean  = false;

  IsVendorOneTime2 = false;
  //IsTH2 = true;
  _ArrAmphur2 = [];
  _ArrTumbon2 = [];
  //#endregion

  _ArrApprove = [];
  _ArrApprove2 = [];
  _ArrWorkFlow = [];
  ArrBusinessArea = [];
  Todate = new Date();
  MinDateForDueDate = new Date();
  holidays: Date[];
  GL_NoData = true;
  isNewRequest: boolean = false;
  isForROS: boolean = false;
  sYear = "";
  IsNotFill_IO = false;
  IsNotFill_GL = false;
  IsNoReturnFull = false;
  IsNotVat = false;
  FieldVendor: any[] = [
    { _Field: "sVendorCode", _Validator: Validators.required, _Value: "" },
    { _Field: "sVendorName", _Validator: Validators.required, _Value: "" },
    { _Field: "sTAXID", _Validator: Validators.required, _Value: "" },
    { _Field: "nOfficeType", _Validator: null, _Value: 1 },
    { _Field: "sVendorBranch", _Validator: null, _Value: "" },
    { _Field: "sVendorAddress", _Validator: Validators.required, _Value: "" },
  ];
  FieldVendorOnetime: any[] = [
    { _Field: "sCountryID", _Validator: Validators.required, _Value: "213" },
    { _Field: "sProvCode", _Validator: Validators.required, _Value: "" },
    { _Field: "sAmpCode", _Validator: Validators.required, _Value: "" },
    { _Field: "sTumbonCode", _Validator: Validators.required, _Value: "" },
    { _Field: "sPostCode", _Validator: Validators.required, _Value: "" },
    { _Field: "sPhoneNumber", _Validator: Validators.required, _Value: "" },
    { _Field: "sFaxNumber", _Validator: Validators.required, _Value: "" },
    { _Field: "sVendorEmail", _Validator: [Validators.required, Validators.pattern("^[^@\\s]+@([^@\\s]+\\.)+[^@\\s]+$")], _Value: "" },
  ];
  FieldVendor2: any[] = [
    { _Field: "sVendorCode2", _Validator: Validators.required, _Value: "" },
    { _Field: "sVendorName2", _Validator: Validators.required, _Value: "" },
    { _Field: "sTAXID2", _Validator: Validators.required, _Value: "" },
    { _Field: "nOfficeType2", _Validator: null, _Value: 1 },
    { _Field: "sVendorBranch2", _Validator: null, _Value: "" },
    { _Field: "sVendorAddress2", _Validator: Validators.required, _Value: "" },
  ];
  FieldVendorOnetime2: any[] = [
    { _Field: "sCountryID2", _Validator: null, _Value: "213" },
    { _Field: "sCountryName2", _Validator: Validators.required, _Value: "ประเทศไทย" },
    { _Field: "sProvCode2", _Validator: null, _Value: "" },
    { _Field: "sProvName2", _Validator: Validators.required, _Value: "" },
    { _Field: "sAmpCode2", _Validator: null, _Value: "" },
    { _Field: "sAmpName2", _Validator: Validators.required, _Value: "" },
    { _Field: "sTumbonCode2", _Validator: null, _Value: "" },
    { _Field: "sTumbonName2", _Validator: Validators.required, _Value: "" },
    { _Field: "sPostCode2", _Validator: null, _Value: "" },
    { _Field: "sPhoneNumber2", _Validator: null, _Value: "" },
    { _Field: "sFaxNumber2", _Validator: null, _Value: "" },
    { _Field: "sVendorEmail2", _Validator: [Validators.pattern("^[^@\\s]+@([^@\\s]+\\.)+[^@\\s]+$")], _Value: "" },
  ];
  FieldInvoice: any[] = [
    { _Field: "sInvoiceNo", _Validator: Validators.required, _Value: "" },
    { _Field: "nIncludeVAT", _Validator: Validators.required, _Value: "" },
    { _Field: "sCurrency", _Validator: null, _Value: "THB" },
    { _Field: "nVAT", _Validator: Validators.required, _Value: "" },
    { _Field: "dInvoiceDate", _Validator: Validators.required, _Value: new Date() },
    { _Field: "sVATType", _Validator: Validators.required, _Value: "" },
    { _Field: "nExcludeVAT", _Validator: Validators.required, _Value: "" },
    { _Field: "nWHTID", _Validator: null, _Value: "" },
    { _Field: "nWHTID2", _Validator: null, _Value: "" },
    { _Field: "nWHTRate", _Validator: null, _Value: "" },
    { _Field: "nWHTRate2", _Validator: null, _Value: "" },
    { _Field: "nWHTVal", _Validator: null, _Value: "" },
    { _Field: "nWHTVal2", _Validator: null, _Value: "" },
    { _Field: "nWHTBase", _Validator: null, _Value: "" },
    { _Field: "nWHTBase2", _Validator: null, _Value: "" },
  ];
  FieldGLValid: string[] = ["sGL", "sCostCenter", "sIO", "sAmountExcludedVAT", "sText"];

  sMSGUrgent = "You have 1 working days before due date.<br>This is \"Urgent\" payment.";
  sOldDate = "";
  HTML_COMMENT = "";
  sComment = "";
  sCommentSSC = "";
  AdvanceText = "Net Amount";
  IsReturnFullAmount: boolean = false;
  //#endregion

  //#region BTN
  btnCancel = false;
  btnSubmit = true;
  btnDraft = true;
  btnRecall = false;
  btnPrint = false;
  IsShowREQ = false;
  IsShowComment = false;
  //#endregion

  dStartDate = new Date();
  nReqUrgentDay = 1;
  fileType: any;
  limitFile: any;
  urgentDay: number = 6;
  //Page Load
  async ngOnInit() {
    ArrFile.length = 0;
    this.System.BlockUI();
    this.SetFromGroup();
    
    let ID: string = this.System.GetQuerySTR('str');
    let ID2: string = this.System.GetQuerySTR('ros');
    this.sRequestID = await this.System.Decrypt(ID);
    if (ID2 !== 'undefined') {
      this.sRequestID = await this.System.Decrypt(ID2);
      this.isForROS = true;
      this.urgentDay = 8;
    }
    if(this.sRequestID === ''){
      this.isNewRequest = true;
    }
    let ua = this.System.GetUserStorage();
    if (ua.IsROService && this.isForROS) {
      this.isReject = true;
    }
    let ObjData = {
      sRequestID: this.sRequestID,
      nMenuID: 7
    }
    await this.getFileType();
    await this.getFileLimit();
    this.PRMS = await this.System.CheckPermission(ObjData);
    let PRMS_ID = await this.System.GetCompanyUSEIO(ObjData);//True เปิด False ปิด
    let PRMS_ID2 = await this.System.GetCompanyUSEGL(ObjData);//True เปิด False ปิด
    this.IsNotFill_IO = !PRMS_ID;
    this.IsNotFill_GL = !PRMS_ID2;

    var setUp = {
      sID: "dvUploadFile", //div สร้างไฟล์
      nFileSize: 15, //max size MB
      Accepts: Accept.GetFix(this.fileType),
      Extensions: Extension.GetFix(this.fileType),
      ModeMulti: true, //multi file
      ArrFile: ArrFile, //array file upload , setup
      View: false,
      HasURL: true,
      UrlUpload: this.System.SiteName + _Path.PathUpload,
      limit: this.limitFile,
    };
    Uploadfiles(setUp);
    Clearuploadfile();

    await this.SetDataControl();
    await this.SetDataPage();
  }
  checkFile() {
    if (ArrFile.filter(f => f.IsDelete === false).length > 0) {
      const chkFile =  document.getElementById('dv_dvUploadFile');
      chkFile.style.border = '1px solid #dde4f6';
    }
    return '';
  }
  async getFileType() {
    await this.http.get(this.System.SiteName + 'api/FileConfig/FileType').toPromise().then((data: Response) => {
      const result = [];
      const item = Object.values(data);
      for (let x = 0; x < item.length; x++ ) {
        if (data[x]['sValue'] === 'Y') {
          result.push(data[x]['sValueText']);
        }
      }
      this.fileType = result;
    });
  }
  async getFileLimit() {
    await this.http.get(this.System.SiteName + 'api/FileConfig/FileLimit').toPromise().then((data: Response) => {
      const result = [];
      const item = Object.values(data);
      for (let x = 0; x < item.length; x++ ) {
        result.push(data[x]['sValue']);
      }
      this.limitFile = result;
    });
  }
  //#region การดำเนินการในส่วน HTTP GET
  async SetDataControl() {
    //RequestType
    let REQ = await this.http.get<any>(this.System.SiteName + "api/_System/_GetRequestType").toPromise();
    if (REQ) {
      this._RequestType = REQ;
    }
    //_VatType
    let VatType = await this.http.get<any>(this.System.SiteName + "api/_System/_GetVatType").toPromise();
    if (VatType) {
      this._VatType = VatType.filter(f => f.sReqType.includes('30'));
    }
    //_WithholdingTax
    let WithholdingTax = await this.http.get<any>(this.System.SiteName + "api/_System/_GetWithholdingTax").toPromise();
    if (WithholdingTax) {
      this._WithholdingTax = WithholdingTax;
    }
    //Currency
    let GetCurrency = await this.http.get<any>(this.System.SiteName + "api/_System/GetCurrency").toPromise();
    if (GetCurrency) {
      this._Currency = GetCurrency;
    }
    //AutoComplete
    const httpOptions_User = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sCompCode", this.InputFrom.controls['sCompCode'].value)
        .set("sRole", "5")
      //.append("sRole", "2")
    };
    let GetAutoComplete_UserByRole = await this.http.get<any>(this.System.SiteName + "api/_System/GetAutoComplete_UserByRole", httpOptions_User).toPromise();
    if (GetAutoComplete_UserByRole) {
      this._ArrEmployee = GetAutoComplete_UserByRole;
    }
    //Get Holidays
    let GetHoliday = await this.http.get<any>(this.System.SiteName + "api/_System/GetHoliday").toPromise();
    if (GetHoliday) {
      //this.holidays = GetHoliday; //get value from Holidaycontroller
      this.holidays = GetHoliday.map(({ dDate }) => new Date(dDate)) //get value from Holidaycontroller
      if (!this.sRequestID) {
        this.CheckToday();
      }
    }
    //CopyofRequest Data
    const httpOptions_GetRequest = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sYear", this.sYear)
        .set("sReqType", this.InputFrom.controls['nReqType'].value)
        .set("sCompCode", this.InputFrom.controls['sCompCode'].value)
        .set("nStatusID", "5")
      //.append("sRole", "2")
    };
    let CopyReqData = await this.http.get<any>(this.System.SiteName + "api/_System/GetRequestData", httpOptions_GetRequest).toPromise();
    if (CopyReqData) {
      this._ArrCopyReqData = CopyReqData; //get value from Holidaycontroller
    }
    //AdvanceData
    const httpOptions_RequestAdvanceType = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sYear", this.sYear)
        .set("sReqType", "20")
        .set("sCompCode", this.InputFrom.controls['sCompCode'].value)
        .set("nStatusID", "13")
      //.append("sRole", "2")
    };
    let AdvanceData = await this.http.get<any>(this.System.SiteName + "api/_System/GetRequestData", httpOptions_RequestAdvanceType).toPromise();
    if (AdvanceData) {
      this._ArrAdvanceData = AdvanceData;
    }
    //Vendor
    const httpOptions_EMP = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sCompCode", this.InputFrom.controls['sCompCode'].value)
        .set("sReqType", "20")
    };
    let EmployeeData = await this.http.get<any>(this.System.SiteName + "api/_System/GetVendor", httpOptions_EMP).toPromise();
    if (EmployeeData) {
      this._ArrEmployeeData = EmployeeData;
    }
    //Vendor
    const httpOptions_Vendor = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sCompCode", this.InputFrom.controls['sCompCode'].value)
        .set("sReqType", this.InputFrom.controls['nReqType'].value)
    };
    let VDNoReqType = await this.http.get<any>(this.System.SiteName + "api/_System/GetVendor", httpOptions_Vendor).toPromise();
    if (VDNoReqType) {
      this._ArrVendorData = VDNoReqType;
    }
    //Vendor OneTime
    const httpOptions_VendorOT = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sComCode", this.InputFrom.controls['sCompCode'].value)
    };
    let VendorOT = await this.http.get<any>(this.System.SiteName + "api/_System/GetVendorOneTime", httpOptions_VendorOT).toPromise();
    if (VendorOT) {
      this._ArrVendorOneTimeData = VendorOT;
    }
    //Country
    let Country = await this.http.get<any>(this.System.SiteName + "api/_System/GetContry").toPromise();
    if (Country) {
      this._ArrCountry = Country;
    }
    //ProvCode
    let ProvCode = await this.http.get<any>(this.System.SiteName + "api/_System/GetProvCode").toPromise();
    if (ProvCode) {
      this._ArrProvince = ProvCode;
    }
    //GL
    const httpOptions_GL = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sCompCode", this.InputFrom.controls['sCompCode'].value)
    };
    let GL = await this.http.get<any>(this.System.SiteName + "api/_System/GetGL", httpOptions_GL).toPromise();
    if (GL) {
      this._ArrVendorGL = GL;
    }
    //CostCenter
    //IO
    const httpOptions_CostCenter = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sCompCode", this.InputFrom.controls['sCompCode'].value)
    };
    let CostCenter = await this.http.get<any>(this.System.SiteName + "api/_System/GetCostCenter", httpOptions_CostCenter).toPromise();
    if (CostCenter) {
      this._ArrVendorCosCentor = CostCenter;
    }
    const httpOptions_IO = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sCompCode", this.InputFrom.controls['sCompCode'].value)
    };
    let IO = await this.http.get<any>(this.System.SiteName + "api/_System/GetIO2", httpOptions_IO).toPromise();
    if (IO) {
      this._ArrVendorIO = IO;
    }
    //Approve 1
    const httpOptions_Approve = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sCompCode", this.InputFrom.controls['sCompCode'].value)
        .set("nRole", "3")
    };
    let Approve1 = await this.http.get<any>(this.System.SiteName + "api/_System/GetApprover", httpOptions_Approve).toPromise();
    if (Approve1) {
      this._ArrApprove = Approve1;
    }
    //Approve 2
    const httpOptions_Approve2 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sCompCode", this.InputFrom.controls['sCompCode'].value)
        .set("nRole", "4")
    };
    let Approve2 = await this.http.get<any>(this.System.SiteName + "api/_System/GetApprover", httpOptions_Approve2).toPromise();
    if (Approve2) {
      this._ArrApprove2 = Approve2;
    }
    //WorkFlow
    const httpOptions_WorkFlow = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sCompCode", this.InputFrom.controls['sCompCode'].value)
        .set("sReqType", this.InputFrom.controls['nReqType'].value)
    };
    let WorkFlow = await this.http.get<any>(this.System.SiteName + "api/_System/GetWorkFlow", httpOptions_WorkFlow).toPromise();
    if (WorkFlow) {
      this._ArrWorkFlow = WorkFlow;
      if (this._ArrWorkFlow[0].IsApprover_1) {
        this.InputFrom.patchValue({
          nApprove1: this._ArrWorkFlow[0].nApproveID1,
          sApprove1: this._ArrWorkFlow[0].sApprove1
        });
      }
      else {
        this.InputFrom.patchValue({
          cSkipApprove1: !this._ArrWorkFlow[0].IsApprover_1,
          nApprove1: null,
          sApprove1: null
        });
        this.InputFrom.get("sApprove1").disable();
      }

      if (this._ArrWorkFlow[0].IsApprover_2) {
        this.InputFrom.patchValue({
          nApprove2: this._ArrWorkFlow[0].nApproveID2,
          sApprove2: this._ArrWorkFlow[0].sApprove2
        });
      }
    }
    const httpOptionsBusinessArea = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sCompCode", this.InputFrom.controls['sCompCode'].value)
    };
    this.http.get<any>(this.System.SiteName + "api/_System/GetBusinessArea", httpOptionsBusinessArea).subscribe(res => {
      this.ArrBusinessArea = res;
      this.InputFrom.patchValue({
        sBusinessArea: this.ArrBusinessArea[0].BUSINESS_AREA
      });
    });
  }
  //#endregion

  SetFromGroup() {
    let ua = this.System.GetUserStorage();

    this.InputFrom = this.formBuilder.group({
      //Section 1
      sRequestCode: [null],
      sCompCode: ua.sCompCode,
      sCompName: ua.sCompName,
      dRequestDate: new Date(),
      nContactID: ua.nUserID,
      sContactName: [ua.sFullName, Validators.required],//
      sUnitName: [ua.sUnitName],
      sEmail: [ua.sEmail, Validators.pattern("^[^@\\s]+@([^@\\s]+\\.)+[^@\\s]+$")],
      sTel: [ua.sTel],
      sBusinessArea: null,

      //Section 2
      nReqType: "30",
      sCopyReqID: [null],
      sCopyRequestCode: [null],
      sRefAdvanceNo: [null, Validators.required],
      sRefAdvanceID: null,
      nInvoiceType: [1],
      dDueDate: [new Date(), Validators.required],
      IsReqUrgent: true,
      sEmployeeName: "",

      sVendorCode: ["", Validators.required],
      sVendorName: ["", Validators.required],
      sTAXID: ["", Validators.required],
      sVendorAddress: ["", Validators.required],
      nOfficeType: [1],
      sVendorBranch: "",

      sCountryID: "",
      sProvCode: "",
      sAmpCode: "",
      sTumbonCode: "",
      sPostCode: "",
      sPhoneNumber: "",
      sFaxNumber: "",
      sVendorEmail: "",

      sVendorCode2: ["", Validators.required],
      sVendorName2: ["", Validators.required],
      sTAXID2: ["", Validators.required],
      sVendorAddress2: ["", Validators.required],
      nOfficeType2: [1],
      sVendorBranch2: "",

      sCountryID2: "",
      sCountryName2: ["", Validators.required],
      sProvCode2: "",
      sProvName2: ["", Validators.required],
      sAmpCode2: "",
      sAmpName2: ["", Validators.required],
      sTumbonCode2: "",
      sTumbonName2: ["", Validators.required],
      sPostCode2: "",
      sPhoneNumber2: "",
      sFaxNumber2: "",
      sVendorEmail2: "",
      sAddressOneTime2: "",

      sInvoiceNo: ["", Validators.required],
      dInvoiceDate: [new Date(), Validators.required],
      sVATType: ["", Validators.required],
      sCurrency: ["THB"],
      nExcludeVAT: ["", Validators.required],
      nVAT: ["", Validators.required],
      nIncludeVAT: [""],//, Validators.required
      nWHTID: "",
      nWHTID2: "",
      nWHTRate: null,
      nWHTRate2: null,
      nWHTVal: null,
      _nWHTVal: null,
      nWHTVal2: null,
      _nWHTVal2: null,
      nWHTBase: null,
      nWHTBase2: null,
      sComment: [null],
      sCommentSSC: [null],

      ArrGL: new FormArray([
        new FormGroup({
          nRowVendor: new FormControl(null),
          nRowVendorInvoice: new FormControl(null),
          sRequestID: new FormControl(''),
          nItemNo: new FormControl(null),
          nLineNo: new FormControl(null),
          sGL: new FormControl('', Validators.required),
          sCostCenter: new FormControl('', Validators.required),
          sText: new FormControl('', Validators.required),
          sIO: new FormControl('', Validators.required),
          sAmountExcludedVAT: new FormControl('', Validators.required),
          IsDelete: new FormControl(false)
        })
      ]),

      //Section 3
      cRefund: "N",
      dRefund: null,
      nGrandTotalAmtInvoice: 0.00,
      nGrandTotalAmtVat: 0.00,
      nGrandTotalWithholdingTax: 0.00,
      nGrandTotalAmt: 0.00,

      nAdvanceAmount: 0.00,
      nCumulativeAmount: 0.00,
      nClearingAmount: 0.00,
      nPayAmount: 0.00,

      //Section 4
      cSkipApprove1: false,
      nApprove1: null,
      sApprove1: ["", Validators.required],
      nApprove2: null,
      sApprove2: ["", Validators.required],
    });
    //this._ArrVendorIO.push([]);
    this.InputFrom.controls['sVendorCode'].disable();
    this.InputFrom.controls['sVendorName'].disable();
    this.InputFrom.controls['sTAXID'].disable();
    this.InputFrom.controls['sVendorAddress'].disable();
    this.InputFrom.controls['sVendorBranch'].disable();

    this.InputFrom.controls['sVendorName2'].disable();
    this.InputFrom.controls['sTAXID2'].disable();
    this.InputFrom.controls['sVendorAddress2'].disable();
    this.InputFrom.controls['sVendorBranch2'].disable();

    this.InputFrom.controls['nWHTRate'].disable();
    this.InputFrom.controls['nWHTRate2'].disable();
    this.InputFrom.controls['dRefund'].disable();
  }
  async SetDataPage() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sRequestID", this.sRequestID)
    };
    this.ArrTransactionHistory = [];
    this.IsNoDataTrans = true;
    var req = '0';
    if(this.sRequestID) req = this.sRequestID;
    let res2 = await this.http.get<any>(this.System.SiteName + "api/_Paytovendor/GetTransactionHistory/" + req).toPromise();
    if (res2) {
      this.ArrTransactionHistory = res2;
      if (this.ArrTransactionHistory.length > 0){
        this.IsNoDataTrans = false;
      }
    }
    let res = await this.http.get<any>(this.System.SiteName + "api/ClearAdvance/SetData", httpOptions).toPromise();
    if (res && !this.isForROS) {

      let TRequest = res[0][0];
      let TRequestItem = res[1][0];
      let TComment = res[2][0];
      let TFile = res[3];

      if (TRequest) {

        let dRequestDate = TRequest.dRequestDate != null ? this.System._ParseDateToNull(TRequest.sRequestDate) : new Date();
        this.IsShowREQ = this.System._IsNullOrEmpty(TRequest.sRequestCode) ? false : true;
        this.IsReturnFullAmount = TRequest.nInvoiceType == 3;

        this.InputFrom.patchValue({
          //Section 1 : Requester Infomation
          sRequestCode: TRequest.sRequestCode,
          sCompCode: TRequest.sCompCode,
          sCompName: this.InputFrom.controls["sCompName"].value,
          dRequestDate: dRequestDate,
          nContactID: TRequest.nContactID,
          sContactName: TRequest.sContactName,
          sUnitName: TRequest.sUnitName,
          sEmail: TRequest.sEmail,
          sTel: TRequest.sTel,

          //Section 2 : Request Items
          sCopyReqID: TRequest.sCopyReqID,
          sCopyRequestCode: TRequest.sCopyRequestCode,
          sRefAdvanceNo: TRequest.sRefAdvanceNo,
          sRefAdvanceID: TRequest.sRefAdvanceID,
          nInvoiceType: this.IsReturnFullAmount ? 3 : 1,
          dDueDate: this.System._ParseDateToNull(TRequest.sDueDate),
          sCurrency: TRequest.sCurrency,

          //Section 3 : Payment Method
          cRefund: TRequest.cRefund,
          dRefund: this.System._ParseDateToNull(TRequest.sRefund),
          nGrandTotalAmtInvoice: TRequest.nGrandTotalAmtInvoice,
          nGrandTotalAmtVat: TRequest.nGrandTotalAmtVat,
          nGrandTotalWithholdingTax: TRequest.nGrandTotalWithholdingTax,
          nGrandTotalAmt: TRequest.nGrandTotalAmt,

          nAdvanceAmount: TRequest.nAdvanceAmount,
          nCumulativeAmount: TRequest.nCumulativeAmount,
          nClearingAmount: TRequest.nClearingAmount,
          nPayAmount: TRequest.nPayAmount,
          IsReqUrgent: TRequest.IsReqUrgent,
          sComment: TRequest.sComment,
          sCommentSSC: TRequest.sComment
        })

        this.HTML_COMMENT = TRequest.sComment;
        this.sComment = TRequest.sComment;
        this.sCommentSSC = TRequest.sCommentSSC;
        if (TRequest.IsRoService) this.urgentDay = 8;

        if (TRequest.sRefAdvanceNo) {
          this.GetAdvanceText();
          this.GetReturnFullAmount();
        }

        this.nReqUrgentDay = TRequest.nReqUrgentDay;

        //Case มีการ Draft Reject Recall
        if (TRequest.nStatusID == 1 || TRequest.nStatusID == 3 || TRequest.nStatusID == 5 || TRequest.nStatusID == 7 || TRequest.nStatusID == 10) {
          var dDueDate = this.System._ParseDateToNull(TRequest.sDueDate);
          var dNowDate = this.Todate = this.BusinessDay.SetToday(this.holidays);
          if (dDueDate < dNowDate) {
            this.MinDateForDueDate = this.BusinessDay.SetToday(this.holidays);
            this.dStartDate = this.MinDateForDueDate;
            this.MinDateForDueDate.setDate(this.MinDateForDueDate.getDate() + 1);
            this.MinDateForDueDate = this.BusinessDay.SetNextDate(this.MinDateForDueDate, this.holidays);
            this.InputFrom.patchValue({ dDueDate: this.MinDateForDueDate });
            var check_date = this.BusinessDay.setDueDatebyDate(this.Todate, this.MinDateForDueDate, this.holidays);
            if (check_date < this.urgentDay) {
              this.sOldDate = "Old Due Date " + TRequest.sDueDate + "<br>";
              this.sMSGUrgent = this.sOldDate + "You have " + check_date + " working days before due date.<br>This is \"Urgent\" payment.";
              this.InputFrom.controls["IsReqUrgent"].setValue(true);
            }
          }
          else {
            this.Todate = this.System._ParseDateToNull(TRequest.sStartDate);
            this.dStartDate = this.System._ParseDateToNull(TRequest.sStartDate);
            if (this.nReqUrgentDay) {
              this.sMSGUrgent = "You have " + this.nReqUrgentDay + " working days before due date.<br>This is \"Urgent\" payment.";
              this.InputFrom.controls["IsReqUrgent"].setValue(true);
            }
            else {
              this.sMSGUrgent = "";
              this.InputFrom.controls["IsReqUrgent"].setValue(false);
            }

            this.MinDateForDueDate = this.BusinessDay.SetToday(this.holidays);
            this.MinDateForDueDate.setDate(this.MinDateForDueDate.getDate() + 1);
            this.MinDateForDueDate = this.BusinessDay.SetNextDate(this.MinDateForDueDate, this.holidays);
          }
        }
        else {
          this.Todate = this.System._ParseDateToNull(TRequest.sStartDate);
          this.dStartDate = this.System._ParseDateToNull(TRequest.sStartDate);
          if (this.nReqUrgentDay) {
            this.sMSGUrgent = "You have " + this.nReqUrgentDay + " working days before due date.<br>This is \"Urgent\" payment.";
            this.InputFrom.controls["IsReqUrgent"].setValue(true);
          }
          else {
            this.sMSGUrgent = "";
            this.InputFrom.controls["IsReqUrgent"].setValue(false);
          }
        }

        if (TRequest.cRefund == "Y") {
          this.InputFrom.get('dRefund').enable();
        }

        switch (TRequest.nStatusID) {
          case 1://Draft
            this.btnCancel = true;
            this.btnSubmit = true;
            this.btnDraft = true;
            this.btnRecall = false;
            this.btnPrint = true;
            //this.PRMS = true;
            break;
          case 2://Wait Approve1
            this.btnCancel = false;
            this.btnSubmit = false;
            this.btnDraft = false;
            this.btnRecall = true;
            this.btnPrint = true;
            break;
          case 0://Cancel
          case 4://Wait Approve2
          case 6://Wait Doc Receiving
          case 8://Wait Adjust Invoice
          case 9://Wait Export to SAP
          case 11://Wait Supporting Document
          case 12://Complete
            this.btnCancel = false;
            this.btnSubmit = false;
            this.btnDraft = false;
            this.btnRecall = false;
            this.btnPrint = false;
            //this.PRMS = false;
            break;
          case 3://Recall
          case 5://Reject By Approve1
          case 7://Reject By Approve2
          case 10://Reject By SSC
            this.btnCancel = true;
            this.btnSubmit = true;
            this.btnDraft = true;
            this.btnRecall = false;
            this.btnPrint = true;
            //this.PRMS = true;
            break;
        }
      }
      if (TRequestItem) {
        //this.InvoiceEdit = 1;
        this.InputFrom.patchValue({
          //Section 2 : Request Items
          // nInvoiceType: TRequestItem.nInvoiceType,
          sVendorCode: TRequestItem.sVendorCode,
          sVendorName: TRequestItem.sVendorName,
          sTAXID: TRequestItem.sTAXID,
          nOfficeType: TRequestItem.nOfficeType,
          sVendorBranch: TRequestItem.sVendorBranch,
          sVendorAddress: TRequestItem.sVendorAddress,
        })

        if (TRequestItem.nOfficeType == 2) {
          this.InputFrom.get('sVendorBranch').enable();
        }

      }
      this.IsShowComment = true;
      

      //UploadFile
      ArrFile.length = 0;
      if (TFile.length != 0) {
        TFile.forEach(f => ArrFile.push({
          nID: f.nFileOrder,
          sPath: f.sPathFile,
          sSystemFileName: f.sSystemFileName,
          sFileName: f.sFileName,
          sSize: parseInt(f.sFileSize)
        }));
        SetData("dvUploadFile", ArrFile)
      }

      this.System.UnBlockUI();
    }
    else {
      if (!this.isNewRequest) {
        let data: any;
      await this.http.get(this.System.SiteName + "api/ROService/GetRequest/" + this.sRequestID + "").toPromise().then(Data => data = Data)
      if(data != null){
        this.InputFrom.patchValue({
          nReqID: data[0].sRequestID,
          sComment: data[0].sComment,
          sCommentSSC: `Expected Complete Date : ${data[0].dExpectedCompleteDate}${data[0].sRemarkSSC ? `\n${data[0].sRemarkSSC}` : ''}`,
        });
        this.sComment = data[0].sComment;
        this.sCommentSSC = data[0].sRemarkSSC;
        this.onSelectContact2(data[0].sFullName);

      }
      this.http.get<any>(this.System.SiteName + "api/PaytoEmployee/GetFle/" + this.sRequestID).subscribe(res => {
        let data = res;
        if (data) {
          let arrdata: any[] = [];
          data.forEach(f => arrdata.push({
            nID: f.nFileOrder,
            sPath: f.sPathFile,
            sSystemFileName: f.sSystemFileName,
            sFileName: f.sFileName,
            sSize: parseInt(f.sFileSize)
          }))
          SetData("dvUploadFile", arrdata)
        }
  
      });
      }

      this.Todate = this.BusinessDay.SetToday(this.holidays);//ใส่แก้บัค
      this.System.UnBlockUI();
    }

    this.GetVendor(this.sRequestID);
    this.GetVendorInvoice(this.sRequestID);
    this.GetApprove(this.sRequestID);

  }

  GetApprove(sRequestID) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sRequestID", sRequestID)
    };
    this.http.get<any>(this.System.SiteName + "api/_System/GetTRequestFlow", httpOptions).subscribe(res => {
      if (res) {
        let _cSkipApprove1 = res[0].cSkipApprove1 == "Y" ? true : false;
        if (_cSkipApprove1) {
          this.InputFrom.get("sApprove1").disable();
        }
        this.InputFrom.patchValue({
          cSkipApprove1: _cSkipApprove1,
          nApprove1: _cSkipApprove1 ? null : res[0].nApprove1,
          sApprove1: _cSkipApprove1 ? null : res[0].sApprove1,
          nApprove2: res[0].nApprove2,
          sApprove2: res[0].sApprove2
        })
      }
    });
  }
  GetRefNo(sRefID) {
    let Result = "";
    var ITEM = this._ArrAdvanceData.filter(w => w.sRequestID == sRefID);
    if (ITEM.length > 0) {
      Result = ITEM[0].sRequestCode;
    }
    return Result;
  }
  GetVendor(sRequestID) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sRequestID", sRequestID)
        .set("sReqType", "30")
    };
    this.http.get<any>(this.System.SiteName + "api/_System/GetTRequestItems", httpOptions).subscribe(res => {
      if (res) {
        this._ArrVendor = res;
      }
      else {
        this._ArrVendor = [];
      }
    });
  }
  CommentChange(event) {
    this.sComment = event.target.value == null ? "" : event.target.value;
  }
  CommentChangeSSC(event) {
    this.sCommentSSC = event.target.value == null ? "" : event.target.value;
  }
  GetVendorInvoice(sRequestID) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sRequestID", sRequestID)
    };
    this.http.get<any>(this.System.SiteName + "api/_System/GetTRequestLineItems", httpOptions).subscribe(res => {
      if (res) {
        this._ArrVendorInvoice = res;
        if (this._ArrVendorInvoice.filter(f => !f.IsDelete).length > 0) {
          this.GL_NoData = false;
        }
        else {
          this.GL_NoData = true;
        }

      }
      else {
        this._ArrVendorInvoice = [];
        this.GL_NoData = true;
      }

      this.CheckCurrency();
    });
  }
  GetVendorCopyRef(sRequestID) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sRequestID", sRequestID)
    };
    this.http.get<any>(this.System.SiteName + "api/_System/GetTRequestItems", httpOptions).subscribe(res => {
      if (res) {
        let Data = res.filter(f => !f.IsDelete);
        this._ArrVendor.forEach(f => f.IsDelete = true);
        let nRowVendorMax = _.maxBy(this._ArrVendor, function (o) { return o.nRowVendor; });
        Data.forEach((value, index) => {
          value.nItemNo = null;
          value.nRowVendor = ((nRowVendorMax ? nRowVendorMax.nRowVendor : 0) + value.nRowVendor)
        });
        Data.forEach(f => this._ArrVendor.push(f));
      }
      else {
        this._ArrVendor = [];
      }
    });
  }
  GetVendorInvoiceCopyRef(sRequestID) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sRequestID", sRequestID)
    };
    this.http.get<any>(this.System.SiteName + "api/_System/GetTRequestLineItems", httpOptions).subscribe(res => {
      if (res) {
        let Data = res.filter(f => !f.IsDelete);
        let nRowVendorMax = _.maxBy(this._ArrVendorInvoice, function (o) { return o.nRowVendor; });
        let nRowVendorLineMax = _.maxBy(this._ArrVendorInvoice, function (o) { return o.nRowVendorInvoice; });
        this._ArrVendorInvoice.forEach(f => {
          f.IsDelete = true, f.cActive = "N"
        });
        Data.forEach((value, index) => {
          value.nItemNo = null,
            value.nLineNo = null,
            value.nRowVendor = ((nRowVendorMax ? nRowVendorMax.nRowVendor : 0) + value.nRowVendor),
            value.nRowVendorInvoice = ((nRowVendorLineMax ? nRowVendorLineMax.nRowVendorInvoice : 0) + value.nRowVendorInvoice)
        });
        Data.forEach(f => this._ArrVendorInvoice.push(f));
        this.GL_NoData = false;
      }
      else {
        this._ArrVendorInvoice = [];
        this.GL_NoData = true;
      }

      this.CheckCurrency();
    });
  }

  //#region DatePicker Event
  //DueDate
  onDueDateSelect(): void {
    var Duedate = this.InputFrom.get('dDueDate').value; //get value dDue formControlName
    let date = Intl.DateTimeFormat('en').format(Duedate);
    let _date = new Date(date);
    //if property doesn't match then do this
    var check_date = this.BusinessDay.setDueDatebyDate(this.Todate, _date, this.holidays);
    if (check_date < this.urgentDay) {
      this.sMSGUrgent = this.sOldDate + 'You have ' + check_date + ' working days before due date.<br>This is "Urgent" payment.'
      this.nReqUrgentDay = check_date;
    } else {
      this.sMSGUrgent = "";
      this.nReqUrgentDay = null;
    }
    this.InputFrom.patchValue({ IsReqUrgent: check_date <= 5 });
  }
  CheckToday() {
    this.MinDateForDueDate = this.BusinessDay.SetToday(this.holidays);
    this.dStartDate = this.MinDateForDueDate;
    this.MinDateForDueDate.setDate(this.MinDateForDueDate.getDate() + 1);
    this.MinDateForDueDate = this.BusinessDay.SetNextDate(this.MinDateForDueDate, this.holidays);
    this.InputFrom.patchValue({ dDueDate: this.MinDateForDueDate });
  }
  //#endregion

  //#region Dropdown Event
  //Province
  GetProvince() {
    this.http.get<any>(this.System.SiteName + "api/_System/GetProvCode").subscribe(res => {
      if (res) {
        this._ArrProvince = res;
      }
    })
  }
  //Amphur
  OnChangeProvince(sCase) {
    let sProvCode = "";
    switch (sCase) {
      case 1:
        sProvCode = this.InputFrom.controls["sProvCode"].value;
        this._ArrTumbon = [];//Clear Tumbon เพื่อให้เลือก Default ค่าว่างไว้
        break;
      case 2:
        sProvCode = this.InputFrom.controls["sProvCode2"].value;
        this._ArrTumbon2 = [];//Clear Tumbon เพื่อให้เลือก Default ค่าว่างไว้
        break;
    }
    const httpOptions_Amphur = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams().set("sProvCode", sProvCode)
    };
    this.http.get<any>(this.System.SiteName + "api/_System/GetAmphur", httpOptions_Amphur).subscribe(res => {
      if (res) {
        switch (sCase) {
          case 1:
            this._ArrAmphur = res;
            break;
          case 2:
            this._ArrAmphur2 = res;
            break;
        }
      }
    });
  }
  //Tumbon
  OnChangeDistrict(sCase) {
    let sAmpCode = "";
    switch (sCase) {
      case 1:
        sAmpCode = this.InputFrom.controls["sAmpCode"].value;
        this._ArrTumbon = [];
        break;
      case 2:
        sAmpCode = this.InputFrom.controls["sAmpCode2"].value;
        this._ArrTumbon2 = [];
        break;
    }
    const httpOptions_Tumbon = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sAmpCode", sAmpCode)
    };
    this.http.get<any>(this.System.SiteName + "api/_System/GetTumbon", httpOptions_Tumbon).subscribe(res => {
      if (res) {
        switch (sCase) {
          case 1:
            this._ArrTumbon = res;
            break;
          case 2:
            this._ArrTumbon2 = res;
            break;
        }
      }
    });
  }
  //WHT
  OnSelectWHT(mode: number) {
    if (mode === 1) {
      this.InputFrom.get("nWHTRate").markAsUntouched({ onlySelf: true });
      if (this.InputFrom.controls["nWHTID"].value + "" === "99" || this.InputFrom.controls["nWHTID"].value + "" === "6") {
        this.InputFrom.get('nWHTRate').enable();
        //Add Validate To Control
        this.InputFrom.controls["nWHTRate"].setValue(null);//Set ค่า
        this.InputFrom.controls["nWHTRate"].setValidators(Validators.required);//กำหนด Validate
        this.InputFrom.controls["nWHTRate"].setErrors(null);//ปรับ Control ให้เป็นปกติ
        this.InputFrom.controls["nWHTRate"].updateValueAndValidity();//Update Validate
      }
      else {
        this.InputFrom.controls["nWHTRate"].setValue(null);//Set ค่า
        this.InputFrom.controls["nWHTRate"].setErrors(null);//ปรับ Control ให้เป็นปกติ
        this.InputFrom.controls["nWHTRate"].clearValidators();
        this.InputFrom.controls["nWHTRate"].disable();
      }
      this.CalculateWHT(1, false);
    }
    else {
      this.InputFrom.get("nWHTRate2").markAsUntouched({ onlySelf: true });
      if (this.InputFrom.controls["nWHTID2"].value + "" === "99" || this.InputFrom.controls["nWHTID2"].value + "" === "6") {
        this.InputFrom.get('nWHTRate2').enable();
        //Add Validate To Control
        this.InputFrom.controls["nWHTRate2"].setValue(null);//Set ค่า
        this.InputFrom.controls["nWHTRate2"].setValidators(Validators.required);//กำหนด Validate
        this.InputFrom.controls["nWHTRate2"].setErrors(null);//ปรับ Control ให้เป็นปกติ
        this.InputFrom.controls["nWHTRate2"].updateValueAndValidity();//Update Validate
      }
      else {
        this.InputFrom.controls["nWHTRate2"].setValue(null);//Set ค่า
        this.InputFrom.controls["nWHTRate2"].setErrors(null);//ปรับ Control ให้เป็นปกติ
        this.InputFrom.controls["nWHTRate2"].clearValidators();
        this.InputFrom.controls["nWHTRate2"].disable();
      }
      this.CalculateWHT(2, false);
    }
  }

  KeyWithholdingAmount(mode: number){
    const _this = this;
    if (this.InputFrom.controls["nWHTID2"].value + "" !== "6") {
      let nWHTVal: number = 0;
      let _nWHTVal: number = 0;
      let nWHTValNew: any;
      let _nWHTValNew: any;
      if (mode == 1) {
          nWHTVal = this.InputFrom.value['nWHTVal'] == null ? null : parseFloat(this.InputFrom.value['nWHTVal'])
          _nWHTVal = this.InputFrom.value['_nWHTVal'] == null ? null : parseFloat(this.InputFrom.value['_nWHTVal'])
          nWHTValNew = _this.InputFrom.value.nWHTVal;
          _nWHTValNew = _this.InputFrom.value._nWHTVal;
      }
      else {
        nWHTVal = this.InputFrom.value['nWHTVal2'] == null ? null : parseFloat(this.InputFrom.value['nWHTVal2'])
        _nWHTVal = this.InputFrom.value['_nWHTVal2'] == null ? null : parseFloat(this.InputFrom.value['_nWHTVal2'])
        nWHTValNew = _this.InputFrom.value.nWHTVal2;
        _nWHTValNew = _this.InputFrom.value._nWHTVal2;
      }
      if (Math.abs(nWHTVal - _nWHTVal) > 1){
        nWHTValNew = _nWHTValNew;
        _this.swal.SwAlert.Error(_this.swal.BoxMsg.Title_Error, _this.swal.BoxMsg.Desc_Error_Amount, null)
      }
      if (mode == 1) {
        _this.InputFrom.patchValue({
          nWHTVal: nWHTValNew,
          _nWHTVal: _nWHTValNew,
        });
      }
      else {
        _this.InputFrom.patchValue({
          nWHTVal2: nWHTValNew,
          _nWHTVal2: _nWHTValNew,
        })
      }
    }
  }

  KeyWithholdingBase(event: any, mode: number) {
    // let nWHTVal = this._ConvertToDecimal((Number(event.target.value)).toFixed(2));
    if (event.target.value === '') {
      if (mode === 1) {
        this.InputFrom.patchValue({
          nWHTBase: '0.00',
        });
      }
      else {
        this.InputFrom.patchValue({
          nWHTBase2: '0.00',
        })
      }
    }
  }

  //Vat
  OnChangeVat() {
    let nExcludeVat = this.System._ParseFloatToZero(this.InputFrom.controls["nExcludeVAT"].value);
    let nVat = this.System._ParseFloatToZero(this.InputFrom.controls["nVAT"].value);
    let nTotal = nExcludeVat + nVat;
    this.InputFrom.patchValue({ nIncludeVAT: this.System._ParseToDecimal(nTotal) });
  }
  //#endregion

  //#region AutoComplete Event
  //Contract
  onSelectContact(event: TypeaheadMatch): void {
    this.InputFrom.patchValue({
      nContactID: event.item.nUserID,
      sUnitName: event.item.sUnit,
      sEmail: event.item.sEmail,
      sTel: event.item.sTel
    })
  }

  onSelectContact2(sName: any) : void {
    let lstData = this._ArrEmployee.filter(user => user.sName + " " + user.sSurName == sName)[0]
    if (lstData != "") {
      this.InputFrom.patchValue({
        nContactID: lstData.nUserID,
        sUnitName: lstData.sUnit,
        sEmail: lstData.sEmail,
        sTel: lstData.sTel,
        sContactName: sName,
      });

    }
  }

  //Copy of Request No.
  OnSelectCopyReqNo(event: TypeaheadMatch): void {
    let This = this;

    this.IsVendorOneTime2 = false;
    this.ClearVendor2();
    this.ClearVendorOneTime2();
    this.InputFrom.controls["sVendorName2"].disable();
    this.InputFrom.controls["sTAXID2"].disable();
    this.InputFrom.controls["sVendorAddress2"].disable();

    this._ArrVendor = [];
    this._ArrVendorInvoice = [];
    this.GetVendorCopyRef(event.item.sRequestID);
    this.GetVendorInvoiceCopyRef(event.item.sRequestID);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sRequestID", event.item.sRequestID)
    };
    this.http.get<any>(this.System.SiteName + "api/ClearAdvance/SetData", httpOptions).subscribe(res => {
      if (res) {

        let TRequest = res[0][0];
        let TRequestItem = res[1][0];
        let TRequestRefAdv = res[4][0];
        if (TRequest) {
          This.InputFrom.patchValue({
            sCurrency: TRequest.sCurrency,
          })
        }

        if (TRequestItem) {
          This.InputFrom.patchValue({
            //Section 2 : Request Items
            sVendorCode: TRequestItem.sVendorCode,
            sVendorName: TRequestItem.sVendorName,
            sTAXID: TRequestItem.sTAXID,
            nOfficeType: TRequestItem.nOfficeType,
            sVendorBranch: TRequestItem.sVendorBranch,
            sVendorAddress: TRequestItem.sVendorAddress,
            nInvoiceType: TRequest.nInvoiceType,
            sRefAdvanceID: TRequest.sRequestID,
            sRefAdvanceNo: TRequest.sRefAdvanceNo,
            nAdvanceAmount: TRequestRefAdv.nAdvanceAmount,
            nCumulativeAmount: TRequestRefAdv.nCumulativeAmount,
            nClearingAmount: TRequest.nGrandTotalAmtInvoice,
            nPayAmount: TRequestRefAdv.nAdvanceAmount - (TRequestRefAdv.nCumulativeAmount + TRequest.nGrandTotalAmtInvoice)
          })

          if (TRequestItem.nOfficeType == 2) {
            this.InputFrom.get('sVendorBranch').enable();
          }

          this.OnChangeReceiptType();

        }
      }
      this.CalCulateGrand();
      this.GetAdvanceText();
    });
    this.InputFrom.patchValue({
      sCopyReqID: event.item.sRequestID
    });
  }
  OnBlurCopyReqNo(event: TypeaheadMatch): void {
    let Pass: boolean = true;
    try {
      if (!event.item.sRequestCode) {
        Pass = false;
      }
    }
    catch (ex) {//กรณีที่พังจะ Reset ค่าทิ้ง
      Pass = false;
    }
    if (Pass) {
      //this.InputFrom.patchValue({
      //  sCopyRequestCode: event.item.sRequestCode,
      //  sCopyReqID: event.item.sRequestID
      //});

      //this.GetVendor(event.item.sRequestID);
      //this.GetVendorInvoice(event.item.sRequestID);
    }
    else {
      this.InputFrom.patchValue({
        sCopyRequestCode: "",
        sCopyReqID: ""
      });
      this._ArrVendor = [];
      this._ArrVendorInvoice = [];
      this.GL_NoData = true;

      //this.IsVendorOneTime2 = false;
      //this.ClearVendor2();
      //this.ClearVendorOneTime2();
      //this.InputFrom.controls["sVendorName2"].disable();
      //this.InputFrom.controls["sTAXID2"].disable();
      //this.InputFrom.controls["sVendorAddress2"].disable();
    }
  }
  //Ref. Advance No.
  OnSelectRefAdvanceNo(event: TypeaheadMatch): void {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sRequestID", this.sRequestID)
        .set("sRefAdvanceNo", event.item.sRequestID)
    };
    this.http.get<any>(this.System.SiteName + "api/ClearAdvance/GetAdvanceOutstand", httpOptions).subscribe(res => {
      if (res) {
        if (res.Status == this.System.SysProcess.Success) {
          let DataRef = JSON.parse(res.Content);
          let _nGrandTotalAmtInvoice = this.InputFrom.controls["nGrandTotalAmtInvoice"].value;
          this.InputFrom.patchValue({
            sRefAdvanceID: DataRef[0].sRequestID,
            sVendorCode: DataRef[0].sVendorCode,
            sVendorName: DataRef[0].sVendorName,
            sTAXID: DataRef[0].sTAXID,
            nOfficeType: DataRef[0].nOfficeType == null ? 1 : 2,
            sVendorBranch: DataRef[0].sVendorBranch,
            sVendorAddress: DataRef[0].sVendorAddress,
            nAdvanceAmount: DataRef[0].nAdvanceAmount,
            nCumulativeAmount: DataRef[0].nCumulativeAmount,
            nClearingAmount: _nGrandTotalAmtInvoice,
            nPayAmount: DataRef[0].nAdvanceAmount - (DataRef[0].nCumulativeAmount + _nGrandTotalAmtInvoice),
          });
          this.GetReturnFullAmount();
          this.GetAdvanceText();
          //this.OnChangeReceiptType();
          switch (DataRef[0].nOfficeType) {
            case 1:
              this.InputFrom.controls["sVendorBranch"].setValue(null);
              this.InputFrom.controls["sVendorBranch"].disable();
              break;
            case 2:
              this.InputFrom.controls["sVendorBranch"].enable();
              break;
          }
        }
        else if (res.Status == this.System.SysProcess.Failed) {
          this.InputFrom.patchValue({
            sRefAdvanceNo: "",
            sRefAdvanceID: "",
          });
          this.swal.SwAlert.Error(this.swal.BoxMsg.Title_Error, res.Msg, function () { Swal.close() });
        }
      }
      else {
        this.IsNoReturnFull = false;
      }
    });
  }
  OnBlurRefAdvanceNo(event: TypeaheadMatch): void {
    let Pass: boolean = true;
    try {
      if (!event.item.sRequestID) {
        Pass = false;
      }
    }
    catch (ex) {//กรณีที่พังจะ Reset ค่าทิ้ง
      Pass = false;
    }
    if (Pass) {
      //this.InputFrom.patchValue({
      //  sEmployeeName: event.item.sContactName
      //});

    }
    else {
      this.InputFrom.patchValue({
        sRefAdvanceNo: "",
        sEmployeeName: "",
        nAdvanceAmount: 0,
        nCumulativeAmount: 0,
        nClearingAmount: 0,
        nPayAmount: 0,
      });
    }

    this.GetReturnFullAmount();
  }

  //Vendor
  OnSelecVendor(event: TypeaheadMatch): void {
    let _Form = this.InputFrom;
    _Form.patchValue({
      sVendorCode: event.item.VENDOR_CODE,
      sVendorName: event.item.VENDORNAME,
      sTAXID: event.item.TAX_ID,
      sVendorAddress: event.item.ADDRESS
    })
    let TYPE: string = !this.System._IsNullOrEmpty(event.item.VENDOR_CODE) ? event.item.VENDOR_CODE.substring(0, 2).toUpperCase() : "";
    switch (TYPE) {
      case "PX":
        this.IsVendorOneTime = true;
        this.FieldVendorOnetime.forEach(function (Item) {
          _Form.get(Item._Field).markAsUntouched({ onlySelf: true });
          _Form.controls[Item._Field].setValue(Item._Value);//Set ค่า
          _Form.controls[Item._Field].setValidators(Item._Validator);//กำหนด Validate
          _Form.controls[Item._Field].setErrors(null);//ปรับ Control ให้เป็นปกติ
          _Form.controls[Item._Field].updateValueAndValidity();//Update Validate
        });
        break;
      case "PF"://กรณีเป็น OneTimeVendor ระบบจะ
        this.IsVendorOneTime = false;
        this.ClearVendorOneTime();
        break;
    }
  }
  OnBlurVendor(event: TypeaheadMatch): void {
    let _Form = this.InputFrom;
    let Pass: boolean = true;
    try {
      if (!event.item.VENDOR_CODE) {
        Pass = false;
      }
    }
    catch (ex) {//กรณีที่พังจะ Reset ค่าทิ้ง
      Pass = false;
    }
    if (Pass) {
      //this.InputFrom.patchValue({
      //  sVendorCode: event.item.VENDOR_CODE,
      //  sVendorName: event.item.VENDOR_NAME,
      //  sTAXID: event.item.TAX_NUMBER,
      //  sVendorAddress: event.item.sAddress,
      //});

      //if (this.IsVendorOneTime) {//เช็คให้ระบบใส่ OneTimevendor
      //  this.ClearVendor();
      //}
      //this.IsVendorOneTime = false;
    }
    else {
      this.InputFrom.patchValue({ sVendorCode: "" });
      //if (!this.IsVendorOneTime) {//เช็คให้ระบบใส่ OneTimevendor
      //  this.FieldVendorOnetime.forEach(function (Item) {
      //    _Form.get(Item._Field).markAsUntouched({ onlySelf: true });
      //    _Form.controls[Item._Field].setValue(Item._Value);//Set ค่า
      //    _Form.controls[Item._Field].setValidators(Item._Validator);//กำหนด Validate
      //    _Form.controls[Item._Field].setErrors(null);//ปรับ Control ให้เป็นปกติ
      //    _Form.controls[Item._Field].updateValueAndValidity();//Update Validate
      //  });
      //}
      //this.IsVendorOneTime = true;
    }
  }
  //Vendor2
  //OnSelecVendor2(event: TypeaheadMatch): void {
  //  let _Form = this.InputFrom;

  //  _Form.controls["sVendorName2"].setErrors(null);
  //  _Form.controls["sVendorName2"].markAsUntouched({ onlySelf: true });
  //  _Form.controls["sTAXID2"].setErrors(null);
  //  _Form.controls["sTAXID2"].markAsUntouched({ onlySelf: true });
  //  _Form.controls["sVendorAddress2"].setErrors(null);
  //  _Form.controls["sVendorAddress2"].markAsUntouched({ onlySelf: true });

  //  if (event.item.IsOnetimeVendor) {
  //    this.IsVendorOneTime2 = true;
  //    this.FieldVendorOnetime2.forEach(function (Item) {
  //      _Form.get(Item._Field).markAsUntouched({ onlySelf: true });
  //      _Form.controls[Item._Field].setValue(Item._Value);//Set ค่า
  //      _Form.controls[Item._Field].setValidators(Item._Validator);//กำหนด Validate
  //      _Form.controls[Item._Field].setErrors(null);//ปรับ Control ให้เป็นปกติ
  //      _Form.controls[Item._Field].updateValueAndValidity();//Update Validate
  //    });

  //    _Form.controls["sVendorName2"].enable();
  //    _Form.controls["sTAXID2"].enable();
  //    _Form.controls["sVendorAddress2"].enable();


  //  }
  //  else {
  //    this.IsVendorOneTime2 = false;
  //    this.ClearVendorOneTime2();

  //    _Form.controls["sVendorName2"].disable();
  //    _Form.controls["sTAXID2"].disable();
  //    _Form.controls["sVendorAddress2"].disable();
  //  }

  //  let sCountryID = "213";
  //  let sCountryName = "";
  //  if (!this.System._IsNullOrEmpty(event.item.sCountryID)) {
  //    sCountryID = event.item.sCountryID + "";
  //  }
  //  let Country = this._ArrCountry.filter(f => f.sCountryID == sCountryID);
  //  if (Country.length > 0) {
  //    sCountryName = Country[0].sCountryName;
  //  }

  //  if (sCountryID == "213") {
  //    this.GetProvince();
  //  }

  //  _Form.patchValue({
  //    sVendorCode2: event.item.VENDOR_CODE,
  //    sVendorName2: event.item.VENDORNAME, //14/7/2020 Issue 419 จากที่คุยตอน Site กรณีเลือก OneTime Vendor ไม่ต้องเอา Vendor name มาแสดง
  //    sTAXID2: event.item.TAX_ID,
  //    nOfficeType2: event.item.nOfficeType,
  //    sVendorBranch2: event.item.sBranch,
  //    sVendorAddress2: event.item.ADDRESS,

  //    sCountryID2: sCountryID,
  //    sCountryName2: sCountryName,
  //    sProvCode2: this.System._ParseString(event.item.sProvCode),
  //    sProvName2: this.System._ParseString(event.item.sProvName),
  //    sAmpCode2: this.System._ParseString(event.item.sAmpCode),
  //    sAmpName2: this.System._ParseString(event.item.sAmpName),
  //    sTumbonCode2: this.System._ParseString(event.item.sTumbonCode),
  //    sTumbonName2: this.System._ParseString(event.item.sTumbonName),
  //    sPostCode2: event.item.sPostCode,
  //    sPhoneNumber2: event.item.TEL,
  //    sFaxNumber2: event.item.sFaxNumber,
  //    sVendorEmail2: event.item.sEMAIL,
  //  })

  //  this.OnChangeProvince(2);
  //  this.OnChangeDistrict(2);

  //  if (event.item.nOfficeType == 1) {
  //    _Form.controls["sVendorBranch2"].disable();
  //  }
  //  else {
  //    _Form.controls["sVendorBranch2"].enable();
  //  }


  //}
  OnSelecVendor2(event: TypeaheadMatch): void {
    let _Form = this.InputFrom;

    _Form.controls["sVendorName2"].setErrors(null);
    _Form.controls["sVendorName2"].markAsUntouched({ onlySelf: true });
    _Form.controls["sTAXID2"].setErrors(null);
    _Form.controls["sTAXID2"].markAsUntouched({ onlySelf: true });
    _Form.controls["sVendorAddress2"].setErrors(null);
    _Form.controls["sVendorAddress2"].markAsUntouched({ onlySelf: true });

    if (event.item.IsOnetimeVendor) {

      //this.FieldVendorOnetime2.forEach(function (Item) {
      //  _Form.get(Item._Field).markAsUntouched({ onlySelf: true });
      //  _Form.controls[Item._Field].setValue(Item._Value);//Set ค่า
      //  _Form.controls[Item._Field].setValidators(Item._Validator);//กำหนด Validate
      //  _Form.controls[Item._Field].setErrors(null);//ปรับ Control ให้เป็นปกติ
      //  _Form.controls[Item._Field].updateValueAndValidity();//Update Validate
      //});

      this.ValidateVendorOneTime2(true);

      _Form.controls["sVendorName2"].enable();
      _Form.controls["sTAXID2"].enable();
      _Form.controls["sVendorAddress2"].enable();

      let sCountryID = "213";
      let sCountryName = "";
      let Country = this._ArrCountry.filter(f => f.sCountryID == sCountryID);
      if (Country.length > 0) {
        sCountryName = Country[0].sCountryName;
      }

      _Form.patchValue({
        sCountryID2: sCountryID,
        sCountryName2: sCountryName
      })

      this.GetProvince();
      //this.OnChangeProvince(2);
      //this.OnChangeDistrict(2);

      this.IsVendorOneTime2 = true;

      _Form.patchValue({
        sVendorCode2: event.item.VENDOR_CODE,
        sVendorName2: "",
        sTAXID2: "",
        nOfficeType2: 1,
        sVendorBranch2: "",
        sVendorAddress2: "",
      })
    }
    else {
      this.IsVendorOneTime2 = false;
      this.ClearVendorOneTime2();

      _Form.controls["sVendorName2"].disable();
      _Form.controls["sTAXID2"].disable();
      _Form.controls["sVendorAddress2"].disable();

      _Form.patchValue({
        sVendorCode2: event.item.VENDOR_CODE,
        sVendorName2: event.item.VENDORNAME, //14/7/2020 Issue 419 จากที่คุยตอน Site กรณีเลือก OneTime Vendor ไม่ต้องเอา Vendor name มาแสดง
        sTAXID2: event.item.TAX_ID,
        nOfficeType2: event.item.nOfficeType,
        sVendorBranch2: event.item.sBranch,
        sVendorAddress2: event.item.ADDRESS,
      })
    }

    if (event.item.nOfficeType == 1) {
      _Form.controls["sVendorBranch2"].disable();
    }
    else {
      _Form.controls["sVendorBranch2"].enable();
    }
  }
  OnBlurVendor2(event: TypeaheadMatch): void {
    let _Form = this.InputFrom;
    let Pass: boolean = true;
    let Item = [];
    try {
      if (event.item.VENDOR_CODE) {
        let sVendor = this.InputFrom.controls["sVendorCode2"].value;
        Item = this._ArrVendorData.filter(f => f.Full_Name == sVendor || f.VENDOR_CODE == sVendor || f.VENDORNAME == sVendor);
        if (Item.length == 1) {
          Pass = true;
        }
        else {
          Pass = false;
        }
      }
      else {
        Pass = false;
      }
    }
    catch (ex) {//กรณีที่พังจะ Reset ค่าทิ้ง
      Pass = false;
    }
    if (Pass) {
      //if (this.IsVendorOneTime2) {//เช็คให้ระบบใส่ OneTimevendor
      //  this.ClearVendor2();
      //}
      //this.IsVendorOneTime2 = false;
      if (Item.length == 1) {


        if (Item[0].IsOnetimeVendor) {//เช็คให้ระบบใส่ OneTimevendor
          _Form.controls["sVendorName2"].enable();
          _Form.controls["sTAXID2"].enable();
          _Form.controls["sVendorAddress2"].enable();

          this.InputFrom.patchValue({
            sVendorCode2: Item[0].VENDOR_CODE,
            sVendorName2: "",
            sTAXID2: "",
            sVendorAddress2: "",
          });

          this.FieldVendorOnetime2.forEach(function (Item) {
            _Form.get(Item._Field).markAsUntouched({ onlySelf: true });
            _Form.controls[Item._Field].setValue(Item._Value);//Set ค่า
            _Form.controls[Item._Field].setValidators(Item._Validator);//กำหนด Validate
            _Form.controls[Item._Field].setErrors(null);//ปรับ Control ให้เป็นปกติ
            _Form.controls[Item._Field].updateValueAndValidity();//Update Validate
          });

          this.IsVendorOneTime2 = true;
        }
        else {
          this.InputFrom.patchValue({
            sVendorCode2: Item[0].VENDOR_CODE,
            sVendorName2: Item[0].VENDORNAME,
            sTAXID2: Item[0].TAX_ID,
            sVendorAddress2: Item[0].ADDRESS,
          });
          this.IsVendorOneTime2 = false;
        }
      }
    }
    else {
      if (!this.IsVendorOneTime2) {//เช็คให้ระบบใส่ OneTimevendor

        _Form.controls["sVendorName2"].enable();
        _Form.controls["sTAXID2"].enable();
        _Form.controls["sVendorAddress2"].enable();

        this.FieldVendorOnetime2.forEach(function (Item) {
          _Form.get(Item._Field).markAsUntouched({ onlySelf: true });
          _Form.controls[Item._Field].setValue(Item._Value);//Set ค่า
          _Form.controls[Item._Field].setValidators(Item._Validator);//กำหนด Validate
          _Form.controls[Item._Field].setErrors(null);//ปรับ Control ให้เป็นปกติ
          _Form.controls[Item._Field].updateValueAndValidity();//Update Validate
        });

        this.IsVendorOneTime2 = true;
      }
    }
  }

  OnSelecVendorName2(event: TypeaheadMatch): void {
    let _Form = this.InputFrom;
    _Form.patchValue({
      //sVendorCode2: event.item.sVendorCode,
      sVendorName2: event.item.sVendorName, //14/7/2020 Issue 419 จากที่คุยตอน Site กรณีเลือก OneTime Vendor ไม่ต้องเอา Vendor name มาแสดง
      sTAXID2: event.item.sTAXID,
      nOfficeType2: event.item.nOfficeType,
      sVendorBranch2: event.item.sBranch,
      sVendorAddress2: event.item.sAddress,

      sCountryID2: event.item.sCountryID,
      sCountryName2: event.item.sCountryName,
      sProvCode2: this.System._ParseString(event.item.sProvCode),
      sProvName2: this.System._ParseString(event.item.sProvName),
      sAmpCode2: this.System._ParseString(event.item.sAmpCode),
      sAmpName2: this.System._ParseString(event.item.sAmpName),
      sTumbonCode2: this.System._ParseString(event.item.sTumbonCode),
      sTumbonName2: this.System._ParseString(event.item.sTumbonName),
      sPostCode2: event.item.sPostCode,
      sPhoneNumber2: event.item.sPhoneNumber,
      sFaxNumber2: event.item.sFaxNumber,
      sVendorEmail2: event.item.sEmail,
    })

    this.IsVendorOneTime2 = true;
  }
  OnBlurVendorName2(event: TypeaheadMatch): void {
    let _Form = this.InputFrom;
    let Pass: boolean = true;
    let Item = [];
    try {
      if (event.item.sVendorName) {
        let sVendor = this.InputFrom.controls["sVendorName2"].value;
        Item = this._ArrVendorOneTimeData.filter(f => f.sVendorName == sVendor);
        if (Item.length == 1) {
          Pass = true;
        }
        else {
          Pass = false;
        }
      }
      else {
        Pass = false;
      }
    }
    catch (ex) {//กรณีที่พังจะ Reset ค่าทิ้ง
      Pass = false;
    }
    if (Pass) {
      if (Item.length == 1) {
        this.InputFrom.patchValue({
          sVendorName2: Item[0].sVendorName, //14/7/2020 Issue 419 จากที่คุยตอน Site กรณีเลือก OneTime Vendor ไม่ต้องเอา Vendor name มาแสดง
          sTAXID2: Item[0].sTAXID,
          nOfficeType2: Item[0].nOfficeType,
          sVendorBranch2: Item[0].sBranch,
          sVendorAddress2: Item[0].sAddress,

          sCountryID2: Item[0].sCountryID,
          sCountryName2: Item[0].sCountryName,
          sProvCode2: this.System._ParseString(Item[0].sProvCode),
          sProvName2: this.System._ParseString(Item[0].sProvName),
          sAmpCode2: this.System._ParseString(Item[0].sAmpCode),
          sAmpName2: this.System._ParseString(Item[0].sAmpName),
          sTumbonCode2: this.System._ParseString(Item[0].sTumbonCode),
          sTumbonName2: this.System._ParseString(Item[0].sTumbonName),
          sPostCode2: Item[0].sPostCode,
          sPhoneNumber2: Item[0].sPhoneNumber,
          sFaxNumber2: Item[0].sFaxNumber,
          sVendorEmail2: Item[0].sEmail,
        });
      }
    }
    else {
      //this.InputFrom.patchValue({
      //  //sVendorName2: "", //14/7/2020 Issue 419 จากที่คุยตอน Site กรณีเลือก OneTime Vendor ไม่ต้องเอา Vendor name มาแสดง
      //  sTAXID2: "",
      //  nOfficeType2: "",
      //  sVendorBranch2: "",
      //  sVendorAddress2: "",

      //  sCountryID2: "",
      //  sCountryName2: "",
      //  sProvCode2: "",
      //  sProvName2: "",
      //  sAmpCode2: "",
      //  sAmpName2: "",
      //  sTumbonCode2: "",
      //  sTumbonName2: "",
      //  sPostCode2: "",
      //  sPhoneNumber2: "",
      //  sFaxNumber2: "",
      //  sVendorEmail2: "",
      //});
    }
  }
  //Approver
  OnSelecApprove(event: TypeaheadMatch, nType): void {
    switch (nType) {
      case 1:
        this.InputFrom.patchValue({ nApprove1: event.item.nUserID });
        break;
      case 2:
        this.InputFrom.patchValue({ nApprove2: event.item.nUserID });
        break;
    }
  }
  OnBlurApprove(event: TypeaheadMatch, nType): void {
    let Pass: boolean = true;
    let sApprover = "";
    try {
      if (event.item.nUserID) {
        switch (nType) {
          case 1:
            sApprover = this.InputFrom.controls["sApprove1"].value;
            Pass = this._ArrApprove.filter(f => f.name == sApprover).length > 0;
            break;
          case 2://กรณีเป็น OneTimeVendor ระบบจะ
            sApprover = this.InputFrom.controls["sApprove2"].value;
            Pass = this._ArrApprove2.filter(f => f.name == sApprover).length > 0;
            break;
        }

      }
      else {
        Pass = false;
      }
    }
    catch (ex) {//กรณีที่พังจะ Reset ค่าทิ้ง
      Pass = false;
    }
    if (Pass) {
      //this.InputFrom.patchValue({
      //  sEmployeeName: event.item.sContactName
      //});

    }
    else {
      switch (nType) {
        case 1:
          this.InputFrom.patchValue({
            nApprove1: null,
            sApprove1: null
          });
          break;
        case 2://กรณีเป็น OneTimeVendor ระบบจะ
          this.InputFrom.patchValue({
            nApprove2: null,
            sApprove2: null
          });
          break;
      }
    }
  }
  //Country
  OnChangeCountry(event: TypeaheadMatch, Case) {
    //let sCountry = this.InputFrom.controls["sCountryID2"].value;
    let sCountry = event.item.sCountryID + "";
    let sCountryName = event.item.sCountryName + "";
    this.InputFrom.patchValue({ sCountryID2: sCountry });
    if (sCountry == "213") {
      //this.IsTH2 = true;
      this.InputFrom.patchValue({ sAddressOneTime2: "" });
      this.InputFrom.controls["sAddressOneTime2"].setValue("");
      this.InputFrom.controls["sAddressOneTime2"].setErrors(null);
      this.InputFrom.controls["sAddressOneTime2"].clearValidators();
      this.ValidateVendorOneTime2(true);
      this.GetProvince();
    }
    else {
      this.InputFrom.patchValue({
        sProvCode2: null,
        sProvName2: null,
        sAmpCode2: null,
        sAmpName2: null,
        sTumbonCode2: null,
        sTumbonName2: null,
      });
      this._ArrProvince = [];
      this._ArrAmphur2 = [];
      this._ArrTumbon2 = [];
      //this.IsTH2 = false;
      //this.InputFrom.controls["sAddressOneTime2"].setValidators(Validators.required);
      ////this.InputFrom.controls["sAddressOneTime2"].markAsTouched({ onlySelf: true });
      //this.InputFrom.controls["sAddressOneTime2"].updateValueAndValidity();//Update Validate
      //this.ValidateVendorOneTime2(false);
      //this.InputFrom.patchValue({ sCountryID2: sCountry });
      //this.InputFrom.patchValue({ sCountryName2: sCountryName });
    }
  }
  OnBlurCheckCountry(event: TypeaheadMatch): void {
    let Pass: boolean = true;
    try {
      if (!event.item.nUserID) {
        Pass = false;
      }
    }
    catch (ex) {//กรณีที่พังจะ Reset ค่าทิ้ง
      Pass = false;
    }
    if (Pass) {
      //this.InputFrom.patchValue({
      //  sEmployeeName: event.item.sContactName
      //});

    }
    else {
      if (event.item.sCountryID == "213") {

      }
      else {
        if (event.item.sCountryID) {
          this.InputFrom.patchValue({
            //sCountryID2: null,
            //sCountryName2: null,
            sProvCode2: null,
            sProvName2: null,
            sAmpCode2: null,
            sAmpName2: null,
            sTumbonCode2: null,
            sTumbonName2: null,
          });
          this._ArrProvince = [];
          this._ArrAmphur2 = [];
          this._ArrTumbon2 = [];
        }
        else {
          this.InputFrom.patchValue({
            sCountryID2: null,
            sCountryName2: null,
            sProvCode2: null,
            sProvName2: null,
            sAmpCode2: null,
            sAmpName2: null,
            sTumbonCode2: null,
            sTumbonName2: null,
          });
        }
      }
    }
  }
  OnChangeProvCode(event: TypeaheadMatch, Case) {
    this.InputFrom.patchValue({ sProvCode2: event.item.sProvCode, sAmpCode2: "", sAmpName2: "", sTumbonCode2: "", sTumbonName2: "" });
    this.OnChangeProvince(Case);
  }
  OnChangeAmpCode(event: TypeaheadMatch, Case) {
    this.InputFrom.patchValue({ sAmpCode2: event.item.sAmpCode, sTumbonCode2: "", sTumbonName2: "" });
    this.OnChangeDistrict(Case);
  }
  OnChangeTumbon(event: TypeaheadMatch) {
    this.InputFrom.patchValue({ sTumbonCode2: event.item.sTumbonCode });
  }
  OnBlurCheckTH(event: TypeaheadMatch, Case) {
    let ISTH = this.InputFrom.controls["sCountryID2"].value == "213";
    if (ISTH)
      switch (Case) {
        case "sProvName2":
          if (!event.item.sProvCode) {
            this.InputFrom.patchValue({ sProvCode2: "", sProvName2: "", sAmpCode2: "", sAmpName2: "", sTumbonCode2: "", sTumbonName2: "" });
          }
          break;
        case "sAmpName2":
          if (!event.item.sAmpCode) {
            this.InputFrom.patchValue({ sAmpCode2: "", sAmpName2: "", sTumbonCode2: "", sTumbonName2: "" });
          }
          break;
        case "sTumbonName2":
          if (!event.item.sTumbonCode) {
            this.InputFrom.patchValue({ sTumbonCode2: "", sTumbonName2: "" });
          }
          break;
      }
  }
  //#endregion

  //#region CheckBox & Radio Event
  //Vat Or WHT
  OnChangeReceiptType() {
    let Invoice = this.InputFrom.controls['nInvoiceType'].value;
    this.IsReturnFullAmount = false;
    this.IsNotVat = false;
    switch (Invoice) {
      case 1:
        this.InputFrom.get('sVendorCode2').enable();
        this.InputFrom.get('sVendorName2').disable();
        this.InputFrom.get('sTAXID2').disable();
        this.InputFrom.get('nOfficeType2').enable();
        this.InputFrom.get('sVendorAddress2').disable();

        this.InputFrom.patchValue({ sVATType: "", nWHTID: "", nWHTID2: "" });//เงื่อนไขเพิ่มเติมจากการประชุมวันที่ 29/04/2563 กรณีเลือกเป็น Vat ระบบจะเคลียและไม่มี D7
        this.InputFrom.get('sVATType').enable();

        this.InputFrom.get('nVAT').enable();
        this.InputFrom.get("nVAT").markAsUntouched({ onlySelf: true });
        this.InputFrom.controls["nVAT"].setValidators(Validators.required);//กำหนด Validate
        this.InputFrom.controls["nVAT"].setErrors(null);//ปรับ Control ให้เป็นปกติ
        this.InputFrom.controls["nVAT"].updateValueAndValidity();//Update Validate

        this.InputFrom.get('nWHTID').enable();
        this.InputFrom.get('nWHTID2').enable();
        this.InputFrom.get('nWHTBase').enable();
        this.InputFrom.get('nWHTBase2').enable();
        this.InputFrom.get("nWHTVal").enable();
        this.InputFrom.get("nWHTVal2").enable();
        //this.InputFrom.get("nWHTID").markAsUntouched({ onlySelf: true });
        //this.InputFrom.controls["nWHTID"].setValidators(Validators.required);//กำหนด Validate
        //this.InputFrom.controls["nWHTID"].setErrors(null);//ปรับ Control ให้เป็นปกติ
        //this.InputFrom.controls["nWHTID"].updateValueAndValidity();//Update Validate

        this.InputFrom.get('cRefund').enable();
        this.InputFrom.get("cRefund").markAsUntouched({ onlySelf: true });
        this.InputFrom.controls["cRefund"].setValidators(Validators.required);//กำหนด Validate
        this.InputFrom.controls["cRefund"].setErrors(null);//ปรับ Control ให้เป็นปกติ
        this.InputFrom.controls["cRefund"].updateValueAndValidity();//Update Validate

        //this.InputFrom.get('dRefund').disable();
        //this.InputFrom.get("dRefund").markAsUntouched({ onlySelf: true });
        //this.InputFrom.controls["dRefund"].setValidators(Validators.required);//กำหนด Validate
        //this.InputFrom.controls["dRefund"].setValue(null);//ปรับ Control ให้เป็นปกติ//ปรับ Control ให้เป็นปกติ
        //this.InputFrom.controls["dRefund"].updateValueAndValidity();//Update Validate
        this.GL_NoData = this._ArrVendorInvoice.filter(w => w.IsDelete == false).length > 0 ? false : true;
        this.CalCulateGrand();
        break;
      case 2:
        this.IsNotVat = true;
        this.ClearVendor2();
        this.InputFrom.get('sVendorCode2').disable();
        this.InputFrom.get('sVendorName2').disable();
        this.InputFrom.get('sTAXID2').disable();
        this.InputFrom.get('nOfficeType2').disable();
        this.InputFrom.get('sVendorAddress2').disable();
        this.ClearVendorOneTime2();

        this.InputFrom.patchValue({ sVATType: "VZ", nWHTID: "", nWHTID2: "" });//เงื่อนไขเพิ่มเติมจากการประชุมวันที่ 29/04/2563 กรณีเลือกเป็น No Vat ระบบจะเป็น VZ และ Disable
        this.InputFrom.get('sVATType').disable();
        this.InputFrom.controls["sVATType"].setErrors(null);
        this.InputFrom.controls["sVATType"].markAsUntouched({ onlySelf: true });

        this.InputFrom.get("nVAT").disable();
        this.InputFrom.get("nVAT").markAsUntouched({ onlySelf: true });
        this.InputFrom.controls["nVAT"].setValue(null);//Set ค่า
        this.InputFrom.controls["nVAT"].setErrors(null);//ปรับ Control ให้เป็นปกติ
        this.InputFrom.controls["nVAT"].clearValidators();//Update Validate

        this.InputFrom.get("nWHTID").disable();
        this.InputFrom.get("nWHTID2").disable();
        this.InputFrom.get("nWHTBase").disable();
        this.InputFrom.get("nWHTBase2").disable();
        this.InputFrom.get("nWHTVal").disable();
        this.InputFrom.get("nWHTVal2").disable();
        
        //this.InputFrom.get("nWHTID").markAsUntouched({ onlySelf: true });
        // this.InputFrom.controls["nWHTID"].setValue(null);//Set ค่า
        // this.InputFrom.controls["nWHTID2"].setValue(null);//Set ค่า
        this.InputFrom.controls["nWHTBase"].setValue(null);//Set ค่า
        this.InputFrom.controls["nWHTBase2"].setValue(null);//Set ค่า
        //this.InputFrom.controls["nWHTID"].setErrors(null);//ปรับ Control ให้เป็นปกติ
        //this.InputFrom.controls["nWHTID"].clearValidators();//Update Validate

        this.InputFrom.get("nWHTRate").disable();
        this.InputFrom.get("nWHTRate2").disable();
        this.InputFrom.get("nWHTRate").markAsUntouched({ onlySelf: true });
        this.InputFrom.get("nWHTRate2").markAsUntouched({ onlySelf: true });
        this.InputFrom.controls["nWHTRate"].setValue(null);//Set ค่า
        this.InputFrom.controls["nWHTRate2"].setValue(null);//Set ค่า
        this.InputFrom.controls["nWHTRate"].setErrors(null);//ปรับ Control ให้เป็นปกติ
        this.InputFrom.controls["nWHTRate2"].setErrors(null);//ปรับ Control ให้เป็นปกติ
        this.InputFrom.controls["nWHTRate"].clearValidators();//Update Validate
        this.InputFrom.controls["nWHTRate2"].clearValidators();//Update Validate

        this.InputFrom.controls["nWHTVal"].setValue(null);//Set ค่า
        this.InputFrom.controls["nWHTVal2"].setValue(null);//Set ค่า

        this.InputFrom.controls["nWHTBase"].setValue(null);//Set ค่า
        this.InputFrom.controls["nWHTBase2"].setValue(null);//Set ค่า
        

        this.InputFrom.get('cRefund').enable();
        this.InputFrom.get("cRefund").markAsUntouched({ onlySelf: true });
        this.InputFrom.controls["cRefund"].setValidators(Validators.required);//กำหนด Validate
        this.InputFrom.controls["cRefund"].setErrors(null);//ปรับ Control ให้เป็นปกติ
        this.InputFrom.controls["cRefund"].updateValueAndValidity();//Update Validate

        //this.InputFrom.get('dRefund').disable();
        //this.InputFrom.get("dRefund").markAsUntouched({ onlySelf: true });
        //this.InputFrom.controls["dRefund"].setValidators(Validators.required);//กำหนด Validate
        //this.InputFrom.controls["dRefund"].setValue(null);//ปรับ Control ให้เป็นปกติ//ปรับ Control ให้เป็นปกติ
        //this.InputFrom.controls["dRefund"].updateValueAndValidity();//Update Validate
        this.GL_NoData = this._ArrVendorInvoice.filter(w => w.IsDelete == false).length > 0 ? false : true;
        this.CalCulateGrand();
        break;
      case 3:
        this.IsReturnFullAmount = true;
        this.ReturnFullAmount_SetControl();

        this.InputFrom.get('cRefund').disable();
        this.InputFrom.get("cRefund").markAsUntouched({ onlySelf: true });
        this.InputFrom.controls["cRefund"].setValidators(Validators.required);//กำหนด Validate
        this.InputFrom.controls["cRefund"].setValue("Y");//ปรับ Control ให้เป็นปกติ
        this.InputFrom.controls["cRefund"].updateValueAndValidity();//Update Validate

        this.InputFrom.get('dRefund').enable();
        this.InputFrom.get("dRefund").markAsUntouched({ onlySelf: true });
        this.InputFrom.controls["dRefund"].setValidators(Validators.required);//กำหนด Validate
        this.InputFrom.controls["dRefund"].setValue(new Date());//ปรับ Control ให้เป็นปกติ//ปรับ Control ให้เป็นปกติ
        this.InputFrom.controls["dRefund"].updateValueAndValidity();//Update Validate

        this.InputFrom.controls["nCumulativeAmount"].setValue(0);
        this.InputFrom.controls["nClearingAmount"].setValue(0);
        this.InputFrom.controls["nPayAmount"].setValue(this.InputFrom.controls["nAdvanceAmount"].value);

        this.InputFrom.controls["nGrandTotalAmt"].setValue(0);
        this.InputFrom.controls["nGrandTotalAmtVat"].setValue(0);
        this.InputFrom.controls["nGrandTotalWithholdingTax"].setValue(0);
        this.InputFrom.controls["nGrandTotalAmtInvoice"].setValue(0);

        this.GL_NoData = true;

        break;
    }
    this.OnChangeVat();
    this.GetAdvanceText();
  }
  //HeadOffice
  CheckHeadOffice(Case) {
    let value = null;
    switch (Case) {
      case 1:
        value = this.InputFrom.controls['nOfficeType'].value;
        if (value == 1) {
          this.InputFrom.get('sVendorBranch').disable();
          this.InputFrom.patchValue({ sVendorBranch: null });
        } else {
          var code = this.InputFrom.get('sVendorBranch').value;
          if (code === '') code = '00000'
          this.InputFrom.get('sVendorBranch').enable();
          this.InputFrom.patchValue({ sVendorBranch: code });
        }
        break;
      case 2:
        value = this.InputFrom.controls['nOfficeType2'].value;
        if (value == 1) {
          this.InputFrom.get('sVendorBranch2').disable();
          this.InputFrom.patchValue({ sVendorBranch2: "" });
        } else {
          var code = this.InputFrom.get('sVendorBranch2').value;
          if (code === '') code = '00000'
          this.InputFrom.get('sVendorBranch2').enable();
          this.InputFrom.patchValue({ sVendorBranch2: code });
        }
        break;
    }
  }
  //Refund
  OnChangeRefund() {
    if (this.InputFrom.controls["cRefund"].value == "Y") {
      this.InputFrom.get('dRefund').enable();
      this.InputFrom.patchValue({ dRefund: this.Todate });
    }
    else {
      this.InputFrom.get('dRefund').disable();
      this.InputFrom.controls['dRefund'].setErrors(null);
      this.InputFrom.controls['dRefund'].markAsUntouched({ onlySelf: true });
      this.InputFrom.patchValue({ dRefund: null });
    }
  }
  //Approver1
  OnSkipApprove1() {
    if (this.InputFrom.controls["cSkipApprove1"].value) {
      this.InputFrom.patchValue({ sApprove1: "" });
      this.InputFrom.get('sApprove1').reset();
      this.InputFrom.get('sApprove1').disable();
    }
    else {
      this.InputFrom.get('sApprove1').enable();
      if (this._ArrWorkFlow.length > 0) {
        if (this._ArrWorkFlow[0].IsApprover_1) {
          this.InputFrom.patchValue({
            nApprove1: this._ArrWorkFlow[0].nApproveID1,
            sApprove1: this._ArrWorkFlow[0].sApprove1
          });
        }
      }
    }
  }
  //#endregion

  //#region Invoice
  //#region Table GL
  OnBlurGCI(event: TypeaheadMatch, _inx, _sType) {
    let FromArray = this.InputFrom.get('ArrGL') as FormArray;
    let FromGroup = FromArray.at(_inx) as FormGroup;
    let Pass: boolean = true;
    let IsValue = "";
    try {
      switch (_sType) {
        case "G":
          if (event.item.GL_ACCOUNT_NO) {
            let sGL = (FromGroup.controls.sGL.value).trim();
            let GL_ITEM = this._ArrVendorGL.filter(f => f.GL_ACCOUNT_NO == sGL || f.name == sGL || f.SHORT_TEXT == sGL);
            Pass = GL_ITEM.length > 0
            if (GL_ITEM.length > 0) {
              IsValue = GL_ITEM[0].GL_ACCOUNT_NO;
            }
          }
          else {
            Pass = false;
          }
          break;
        case "C":
          if (event.item.COST_CENTER) {
            let sCostCenter = (FromGroup.controls.sCostCenter.value).trim();
            let CostCenter_ITEM = this._ArrVendorCosCentor.filter(f => f.COST_CENTER == sCostCenter || f.name == sCostCenter || f.DESCRIPTION == sCostCenter);
            Pass = CostCenter_ITEM.length > 0
            if (CostCenter_ITEM.length > 0) {
              IsValue = CostCenter_ITEM[0].COST_CENTER;
            }
          }
          else {
            Pass = false;
          }
          break;
        case "I":
          if (event.item.ORDER_NUMBER) {
            let sIO = (FromGroup.controls.sIO.value).trim();
            let IO_ITEM = this._ArrVendorIO.filter(f => f.ORDER_NUMBER == sIO || f.name == sIO || f.DESCRIPTION == sIO);
            Pass = IO_ITEM.length > 0
            if (IO_ITEM.length > 0) {
              IsValue = IO_ITEM[0].ORDER_NUMBER;
            }
          }
          else {
            Pass = false;
          }
          break;
      }
    }
    catch (ex) {//กรณีที่พังจะ Reset ค่าทิ้ง
      Pass = false;
    }
    if (Pass) {
      switch (_sType) {
        case "G":
          FromArray.at(_inx).patchValue({ sGL: IsValue });
          break;
        case "C":
          FromArray.at(_inx).patchValue({ sCostCenter: IsValue });
          break;
        case "I":
          FromArray.at(_inx).patchValue({ sIO: IsValue });
          break;
      }
    }
    else {
      switch (_sType) {
        case "G":
          FromArray.at(_inx).patchValue({ sGL: "" });
          break;
        case "C":
          FromArray.at(_inx).patchValue({ sCostCenter: "" });
          break;
        case "I":
          FromArray.at(_inx).patchValue({ sIO: "" });
          break;
      }
    }
  }
  OnSelectGCI(event: TypeaheadMatch, _inx, _sType) {
    let FromArray = this.InputFrom.get('ArrGL') as FormArray;
    let sGL = FromArray.at(_inx).get("sGL").value;
    let sCostCenter = FromArray.at(_inx).get("sCostCenter").value;
    let sIO = (FromArray.at(_inx).get("sIO").value != null) ? FromArray.at(_inx).get("sIO").value : ""; //แก้ไขกรณี company ไม่มี IO

    let SP_GL = sGL.split('-');
    let SP_CCTR = sCostCenter.split('-');
    let SP_IO = sIO.split('-');

    let SE_GL = SP_GL.length > 1 ? (SP_GL[0] + "").trim() : sGL;
    let SE_CCTR = SP_CCTR.length > 1 ? (SP_CCTR[0] + "").trim() : sCostCenter;
    let SE_IO = SP_IO.length > 1 ? (SP_IO[0] + "").trim() : sIO;

    let _CHK = this.OnChange_CheckDuplicateGCI(SE_GL, SE_CCTR, SE_IO, _inx);
    if (false) {
    //if (!_CHK.IsPass) {
      switch (_sType) {
        case "G":
          FromArray.at(_inx).patchValue({ sGL: "" });
          break;
        case "C":
          FromArray.at(_inx).patchValue({ sCostCenter: "" });
          break;
        case "I":
          FromArray.at(_inx).patchValue({ sIO: "" });
          break;
      }
      this.swal.SwAlert.Error(this.swal.BoxMsg.Title_Error, _CHK.Msg, function () { Swal.close(); });
    }
    else {
      switch (_sType) {
        case "G":
          FromArray.at(_inx).patchValue({ sGL: event.item.GL_ACCOUNT_NO });
          break;
        case "C":
          FromArray.at(_inx).patchValue({ sCostCenter: event.item.COST_CENTER });
          break;
        case "I":
          FromArray.at(_inx).patchValue({ sIO: event.item.ORDER_NUMBER });
          break;
      }
    }
  }

  AddGL() {
    this.ArrGL.push(new FormGroup({
      nRowVendor: new FormControl(null),
      nRowVendorInvoice: new FormControl(null),
      sRequestID: new FormControl(''),
      nItemNo: new FormControl(null),
      nLineNo: new FormControl(null),
      sGL: new FormControl('', Validators.required),
      sCostCenter: new FormControl('', Validators.required),
      sText: new FormControl('', Validators.required),
      sIO: new FormControl('', Validators.required),
      sAmountExcludedVAT: new FormControl('', Validators.required),
      IsDelete: new FormControl(false)
    }));
    //this._ArrVendorIO.push([]);
  }
  DeleteGL(_Index) {
    var _this = this;
    let FromArray = _this.InputFrom.get('ArrGL') as FormArray;
    FromArray.at(_Index).get("sGL").clearValidators();
    FromArray.at(_Index).get("sCostCenter").clearValidators();
    FromArray.at(_Index).get("sIO").clearValidators();
    this.swal.SwAlert.Confirm(this.swal.BoxMsg.Title_Confirm, this.swal.BoxMsg.Desc_Confirm_Delete, function () {
      _this.ArrGL.at(_Index).patchValue({ IsDelete: true });
    }, function () { });
  }
  OnChange_CheckDuplicateGCI(sGL, sCostCenter, sIO, _inx) {
    let Result = { IsPass: true, Msg: "" };
    //Case 1 เช็คจาก Array Invoice
    for (var i = 0; i < this.ArrGL.length; i++) {
      if (i != _inx) {//ตรวจสอบ Index ว่าต้องไม่เป็น Index กับตัวที่ Select
        let Isdelete = this.ArrGL.value[i].IsDelete;
        let _sGL = this.ArrGL.value[i].sGL;
        let _sCostCenter = this.ArrGL.value[i].sCostCenter;
        let _sIO = this.ArrGL.value[i].sIO;
        if (!Isdelete) {
          if (this.IsNotFill_IO) {//IsNotFill_IO คือระบบไม่ต้องกรอก IO
            if (!this.System._IsNullOrEmpty(sGL) && !this.System._IsNullOrEmpty(sCostCenter)) {//เช็คแค่ GL,CostCenter
              if (sGL == _sGL && sCostCenter == _sCostCenter) {
                Result.IsPass = false;
                Result.Msg = this.swal.BoxMsg.Desc_Invoice_GCI;
                return Result;
              }
            }
          }
          if (this.IsNotFill_IO && this.IsNotFill_GL) {//IsNotFill_IO คือระบบไม่ต้องกรอก IO && IsNotFill_GL คือระบบไม่ต้องกรอก GL
            if (!this.System._IsNullOrEmpty(sCostCenter)) {//เช็คแค่ CostCenter
              if (sCostCenter == _sCostCenter) {
                Result.IsPass = false;
                Result.Msg = this.swal.BoxMsg.Desc_Invoice_GCI;
                return Result;
              }
            }
          }
          else if (this.IsNotFill_IO) {//IsNotFill_IO คือระบบไม่ต้องกรอก IO
            if (!this.System._IsNullOrEmpty(sGL) && !this.System._IsNullOrEmpty(sCostCenter)) {//เช็คแค่ GL,CostCenter
              if (sGL == _sGL && sCostCenter == _sCostCenter) {
                Result.IsPass = false;
                Result.Msg = this.swal.BoxMsg.Desc_Invoice_GCI;
                return Result;
              }
            }
          }
          else if (this.IsNotFill_GL) {//IsNotFill_GL คือระบบไม่ต้องกรอก GL
            if (!this.System._IsNullOrEmpty(sIO) && !this.System._IsNullOrEmpty(sCostCenter)) {//เช็คแค่ IO,CostCenter
              if (sIO == _sIO && sCostCenter == _sCostCenter) {
                Result.IsPass = false;
                Result.Msg = this.swal.BoxMsg.Desc_Invoice_GCI;
                return Result;
              }
            }
          }
          else {
            if (sGL == _sGL && sCostCenter == _sCostCenter && sIO == _sIO) { //เช็คแค่ GL,CostCenter , IO
              Result.IsPass = false;
              Result.Msg = this.swal.BoxMsg.Desc_Invoice_GCI;
              return Result;
            }
          }
        }
      }
    }

    //Case 2 เช็คจาก Array GL ที่กรอก
    //if (Result.IsPass) {
    //  let DupInvoice = this._ArrVendorInvoice.filter(w =>
    //    w.sGL == sGL
    //    && w.sCostCenter == sCostCenter
    //    && (sIO == null ? true : (w.sIO != sIO))
    //    && w.IsDelete == false
    //    && (this.InvoiceEdit == null ? true : (w.nRowVendor != this.InvoiceEdit))//ตรวจสอบว่า InvoiceEdit มีค่าไหมถ้าไม่มีระบบจะไม่สนใจเงื่อนไขนี้ แต่ถ้ามีจะหาตัวที่ไม่เท่ากับ nRowVendor ที่กด Edit มา
    //  );
    //  if (DupInvoice.length > 0) {
    //    Result.IsPass = false;
    //    Result.Msg = this.swal.BoxMsg.Desc_Invoice_GCI;;
    //  }
    //}


    return Result;
  }
  CheckDuplicateGCI(sGL, sCostCenter, sIO, _inx) {
    let Result = { IsPass: true, Msg: "" };
    //Case 1 เช็คจาก Database
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sGL", sGL)
        .set("sCostCenter", sCostCenter)
        .set("sIO", sIO)
    };
    this.http.get<any>(this.System.SiteName + "api/_System/CheckDuplicateGCI", httpOptions).subscribe(res => {
      if (res) {
        if (res.length > 0) {
          Result.IsPass = false;
          Result.Msg = this.swal.BoxMsg.Desc_Invoice_GCI;
        }
        else {
          Result.IsPass = true;
        }
      }
      else {
        Result.IsPass = true;
      }
    });


    return Result;
  }
  //#endregion
  //#endregion
  async Reject() {
    let _this = this;
    let sComment = _this.sComment;
    if (sComment === null || sComment === "") {
      _this.swal.SwAlert.Error(_this.swal.BoxMsg.Title_Error, _this.swal.BoxMsg.Desc_Specify_Comment, undefined)
    }
    else{
      let DataSave = {
        TRequest: {
          sRequestID: _this.sRequestID,
          sComment: _this.sComment
        },
      }
      let Data = JSON.stringify(DataSave)
      let save = function () {
        _this.System.BlockUI();
        const headers = new HttpHeaders({
          'Content-Type': 'application/json'
        });
        _this.http.post(_this.System.SiteName + "api/ROService/Reject", Data, { headers, responseType: 'text' }).subscribe(s => {
          if (s == "Success") {
            ArrFile = [];
            _this.System.UnBlockUI();
            _this.swal.SwAlert.Success(_this.swal.BoxMsg.Title_Success, _this.swal.BoxMsg.Desc_SaveComplete, function () { _this.router.navigate(["ro-service"]) });
          } else {
            _this.System.UnBlockUI();
          }
        });
      }
      _this.swal.SwAlert.Confirm(_this.swal.BoxMsg.Title_Confirm, _this.swal.BoxMsg.Desc_Confirm_Submit, save, function () { });
    }
  }

  onSubmit(sMode) {
    let Confirm_Desc = "";
    switch (sMode) {
      case "D":
        Confirm_Desc = this.swal.BoxMsg.ConfirmSaveDraft;
        break;
      case "S":
        Confirm_Desc = this.swal.BoxMsg.Desc_Confirm_Submit;
        break;
    }

    let IsValid: boolean = this.CheckSubmitValid(sMode);
    if ((ArrFile.filter(f => f.IsDelete === false).length <= 0) && sMode !== 'D') {
    // if ((ArrFile.filter(f => f.IsDelete === false).length <= 0) && this.InputFrom.controls['nInvoiceType'].value !== 3 && sMode !== 'D') {
      IsValid = false;
      const chkFile =  document.getElementById('dv_dvUploadFile');
      chkFile.style.border = '1px solid red';
    }
    if (IsValid) {
      let _this = this;
      this.swal.SwAlert.Confirm(this.swal.BoxMsg.Title_Confirm, Confirm_Desc,
        function () {
          _this.System.BlockUI();

          //#region Case Return Full Amount
          //ตรวจสอบว่า nInvoiceType เป้น Return Full Amount ไหม
          if (_this.InputFrom.controls['nInvoiceType'].value == 3) {
            //ถ้าเป็นตรวจสอบ _ArrVendor มีหรือไม่เนื่องจากระบบจะต้องมี Vender Type M
            let Check_Vendor = _this._ArrVendor.filter(w => w.cVenderMaster == "M" && !w.IsDelete);
            if (Check_Vendor.length == 0) {//ถ้าไม่มีระบบจะเพื่ม Vendor M ไป
              _this._ArrVendor.push({
                IsVendorOneTime: false,
                nRowVendor: 1,
                sRequestID: _this.sRequestID,
                nItemNo: null,
                cVenderMaster: "M",
                sVendorCode: _this.InputFrom.controls['sVendorCode'].value,
                sVendorName: _this.InputFrom.controls['sVendorName'].value,
                sTAXID: _this.InputFrom.controls['sTAXID'].value,
                nOfficeType: _this.InputFrom.controls['nOfficeType'].value,
                sVendorBranch: _this.System._ParseString(_this.InputFrom.controls['sVendorBranch'].value),
                sVendorAddress: _this.InputFrom.controls['sVendorAddress'].value,
                nInvoiceType: _this.InputFrom.controls['nInvoiceType'].value,
                IsDelete: false
              });
            }
            else {
              Check_Vendor[0].sVendorCode = _this.InputFrom.controls['sVendorCode'].value;
              Check_Vendor[0].sVendorName = _this.InputFrom.controls['sVendorName'].value;
              Check_Vendor[0].sTAXID = _this.InputFrom.controls['sTAXID'].value;
              Check_Vendor[0].nOfficeType = _this.InputFrom.controls['nOfficeType'].value;
              Check_Vendor[0].sVendorBranch = _this.InputFrom.controls['sVendorBranch'].value;
              Check_Vendor[0].sVendorAddress = _this.InputFrom.controls['sVendorAddress'].value;
              Check_Vendor[0].nInvoiceType = _this.InputFrom.controls['nInvoiceType'].value;
            }
          }
          //#endregion

          const headers = new HttpHeaders({
            'Content-Type': 'application/json',
          });
          let _Data = {
            //Section 1
            sRequestID: _this.System._ParseString(_this.sRequestID),
            sMode: sMode,
            sCompCode: _this.System._ParseString(_this.InputFrom.controls['sCompCode'].value),
            nContactID: _this.System.ParseIntToNull(_this.InputFrom.controls['nContactID'].value),
            sContactName: _this.System._ParseString(_this.InputFrom.controls['sContactName'].value),
            sUnitName: _this.System._ParseString(_this.InputFrom.controls['sUnitName'].value),
            sEmail: _this.System._ParseString(_this.InputFrom.controls['sEmail'].value),
            sTel: _this.System._ParseString(_this.InputFrom.controls['sTel'].value),
            sBusinessArea: _this.System._ParseString(_this.InputFrom.controls['sBusinessArea'].value),

            //Section 2
            sCopyReqID: _this.System._ParseString(_this.InputFrom.controls['sCopyReqID'].value),
            sRefAdvanceNo: _this.System._ParseString(_this.InputFrom.controls['sRefAdvanceID'].value),
            dDueDate: _this.InputFrom.controls['dDueDate'].value,
            sStartDate: _this.System._ParseDateToFormat(_this.Todate, ''),
            sDueDate: _this.System._ParseDateToFormat(_this.InputFrom.controls['dDueDate'].value, ''),
            IsReqUrgent: _this.InputFrom.controls['IsReqUrgent'].value,
            nReqUrgentDay: _this.System.ParseIntToNull(_this.nReqUrgentDay),
            sCurrency: _this.InputFrom.controls['sCurrency'].value,

            nInvoiceType: _this.InputFrom.controls['nInvoiceType'].value,
            sVendorCode: _this.InputFrom.controls['sVendorCode'].value,
            sVendorName: _this.InputFrom.controls['sVendorName'].value,
            sTAXID: _this.InputFrom.controls['sTAXID'].value,
            nOfficeType: _this.InputFrom.controls['nOfficeType'].value,
            sVendorBranch: _this.InputFrom.controls['sVendorBranch'].value,
            sVendorAddress: _this.InputFrom.controls['sVendorAddress'].value,

            //Section 3
            cRefund: _this.InputFrom.controls['cRefund'].value,
            dRefund: _this.InputFrom.controls['dRefund'].value,
            sRefund: _this.System._ParseDateToFormat(_this.InputFrom.controls['dRefund'].value, ''),

            nAdvanceAmount: _this.System._ParseFloatToZero(_this.InputFrom.controls['nAdvanceAmount'].value),
            nCumulativeAmount: _this.System._ParseFloatToZero(_this.InputFrom.controls['nCumulativeAmount'].value),
            nClearingAmount: _this.System._ParseFloatToZero(_this.InputFrom.controls['nClearingAmount'].value),
            nPayAmount: _this.System._ParseFloatToZero(_this.InputFrom.controls['nPayAmount'].value),

            nGrandTotalAmtInvoice: _this.System._ParseFloatToZero(_this.InputFrom.controls['nGrandTotalAmtInvoice'].value),
            nGrandTotalAmtVat: _this.System._ParseFloatToZero(_this.InputFrom.controls['nGrandTotalAmtVat'].value),
            nGrandTotalWithholdingTax: _this.System._ParseFloatToZero(_this.InputFrom.controls['nGrandTotalWithholdingTax'].value),
            nGrandTotalAmt: _this.System._ParseFloatToZero(_this.InputFrom.controls['nGrandTotalAmt'].value),

            //Section 4
            cSkipApprove1: _this.InputFrom.controls['cSkipApprove1'].value,
            nApprove1: _this.InputFrom.controls['nApprove1'].value,
            nApprove2: _this.InputFrom.controls['nApprove2'].value,

            sComment: _this.sComment,
            sCommentSSC: _this.sCommentSSC,

            TRequestItems: _this._ArrVendor,
            TRequestLineItems: _this._ArrVendorInvoice,
            TRequestFile: ArrFile
          }
          const options = { headers: { 'Content-Type': 'application/json' } };
          let ITEM = JSON.stringify(_Data);
          _this.http.post<any>(_this.System.SiteName + "api/ClearAdvance/SaveData", ITEM, options).subscribe(res => {
            _this.System.UnBlockUI();
            if (res.Status == _this.System.SysProcess.SessionExpired) {
              _this.System.SessionExpire();
            }
            else if (res.Status == _this.System.SysProcess.Success) {
              _this.swal.SwAlert.Success(_this.swal.BoxMsg.Title_Success, _this.swal.BoxMsg.Desc_SaveComplete, function () {
                _this.router.navigate(['/home']);
                //Swal.close();
              });
            }
            else {
              _this.swal.SwAlert.Error(_this.swal.BoxMsg.Title_Error, res.Msg, function () { Swal.close(); });
            }
          });
        }, function () {
          Swal.close();
        })
    }
    else {

    }
    this.clicked = false;
  }
  UpdateStatus(sMode) {
    let _this = this;
    let Confirm_Desc = "";
    if ((_this.sComment === null || _this.sComment === "") && sMode === "D") {
      this.swal.SwAlert.Error(this.swal.BoxMsg.Title_Error, this.swal.BoxMsg.Desc_Specify_Comment, undefined)
    } else {
      switch (sMode) {
        case "D":
          Confirm_Desc = this.swal.BoxMsg.Desc_Confirm_Delete;
          break;
        case "R":
          Confirm_Desc = this.swal.BoxMsg.Desc_Confirm_Recall;
          break;
      }
      this.swal.SwAlert.Confirm(this.swal.BoxMsg.Title_Confirm, Confirm_Desc,
        function () {
          const headers = new HttpHeaders({
            'Content-Type': 'application/json',
          });
          let _Data = {
            //Section 1
            sRequestID: _this.System._ParseString(_this.sRequestID),
            sMode: sMode,
          }
          let ITEM = JSON.stringify(_Data);
          _this.http.post(_this.System.SiteName + "api/ClearAdvance/UpdateStatus/" + _this.sComment, ITEM, { headers, responseType: 'text' }).subscribe(res => {
            if (res) {
              _this.swal.SwAlert.Error(_this.swal.BoxMsg.Title_Warning, res, function () { Swal.close(); });
            }
            else {
              _this.swal.SwAlert.Success(_this.swal.BoxMsg.Title_Success, _this.swal.BoxMsg.Desc_SaveComplete, function () {
                _this.router.navigate(["/home"])
              });
            }
          });
        }, function () {
          Swal.close();
        })
    }


  }
  CheckSubmitValid(sMode) {
    let IsValid: boolean = true;
    let _FormGroup = this.InputFrom;
    switch (sMode) {
      case "D":
        if (!_FormGroup.get("sContactName").valid) {
          IsValid = false;
          const control = _FormGroup.get("sContactName");
          if (control instanceof FormControl) {
            control.markAsTouched({ onlySelf: true });
          }
          return false;
        }
        break;
      case "S":
        let FieldSubmit: any[] = ["sContactName", "sRefAdvanceNo", "dDueDate", "sApprove1", "sApprove2"];
        FieldSubmit.forEach(function (Item) {
          if (!_FormGroup.get(Item).valid && !_FormGroup.get(Item).disabled) {
            IsValid = false;
            const control = _FormGroup.get(Item);
            if (control instanceof FormControl) {
              control.markAsTouched({ onlySelf: true });
            }
            return false;
          }
        });

        if (this.InputFrom.controls["nInvoiceType"].value != 3) {
          var CHK_VALID = this._ArrVendorInvoice.filter(w => w.IsDelete == false);
          if (CHK_VALID.length == 0) {
            IsValid = this.CheckInvoiceValid();
          }
        }

        if (!IsValid) {
          var elmnt = document.getElementById("DIV_FormData").querySelectorAll(".has-error");
          if (elmnt.length > 0) {
            elmnt[0].scrollIntoView();
          }
        }
        break;
    }

    return IsValid;
  }
  onBack() {
    this.router.navigate(["/home"])
  }

  //#region Invoice
  InvoiceEdit = null;
  async AddInvoice() {
    this.System.BlockUI();
    let _FormGroup = this.InputFrom;
    //CheckValidate
    let IsValid: boolean = await this.CheckInvoiceValid();
    //Check Invoice
    let _CheckDup: any = await this.CheckDuplicateData();
    if (IsValid) {
      if (_CheckDup.IsPass) {
        let IsPass = true;
        if (!this.IsNotVat) {
          //#region Check Name TaxID Address
          if (this.System._IsNullOrEmpty(this.InputFrom.controls['sVendorName'].value)
            || this.System._IsNullOrEmpty(this.InputFrom.controls['sTAXID'].value)
            || this.System._IsNullOrEmpty(this.InputFrom.controls['sVendorAddress'].value)
            || this.System._IsNullOrEmpty(this.InputFrom.controls['sVendorName2'].value)
            || this.System._IsNullOrEmpty(this.InputFrom.controls['sTAXID2'].value)
            || this.System._IsNullOrEmpty(this.InputFrom.controls['sVendorAddress2'].value)
          ) {
            IsPass = false;
          }
        }
        else {//กรณี No Vat No Wht

        }


        //#endregion
        if (IsPass) {
          let nRowVendor = 0;
          if (this.InvoiceEdit == null) {
            nRowVendor = this._ArrVendor.length + 1;
          }
          else {
            nRowVendor = this.InvoiceEdit;
          }
          //#region cVenderMaster = M
          let UpdateVenodorMaster = this._ArrVendor.filter(w => w.cVenderMaster == "M" && w.IsDelete == false);
          if (UpdateVenodorMaster.length > 0) {
            UpdateVenodorMaster[0].IsVendorOneTime = this.IsVendorOneTime;
            UpdateVenodorMaster[0].sVendorCode = this.InputFrom.controls['sVendorCode'].value;
            UpdateVenodorMaster[0].sVendorName = this.InputFrom.controls['sVendorName'].value;
            UpdateVenodorMaster[0].sTAXID = this.InputFrom.controls['sTAXID'].value;
            UpdateVenodorMaster[0].nOfficeType = this.InputFrom.controls['nOfficeType'].value;
            UpdateVenodorMaster[0].sVendorBranch = this.InputFrom.controls['sVendorBranch'].value;
            UpdateVenodorMaster[0].sVendorAddress = this.InputFrom.controls['sVendorAddress'].value;

            UpdateVenodorMaster[0].sCountryID = this.InputFrom.controls['sCountryID'].value;
            UpdateVenodorMaster[0].sProvCode = this.InputFrom.controls['sProvCode'].value;
            UpdateVenodorMaster[0].sAmpCode = this.InputFrom.controls['sAmpCode'].value;
            UpdateVenodorMaster[0].sTumbonCode = this.InputFrom.controls['sTumbonCode'].value;
            UpdateVenodorMaster[0].sPostCode = this.InputFrom.controls['sPostCode'].value;
            UpdateVenodorMaster[0].sPhoneNumber = this.InputFrom.controls['sPhoneNumber'].value;
            UpdateVenodorMaster[0].sFaxNumber = this.InputFrom.controls['sFaxNumber'].value;
            UpdateVenodorMaster[0].sEmail = this.InputFrom.controls['sVendorEmail'].value;

            //เอาส่วน Invoice ออกเเพราะมีผลต่อการคำนวน
            //UpdateVenodorMaster[0].sInvoiceNo = this.InputFrom.controls['sInvoiceNo'].value;
            //UpdateVenodorMaster[0].dInvoiceDate = this.InputFrom.controls['dInvoiceDate'].value;
            //UpdateVenodorMaster[0].sInvoiceDate = this.System._ParseDateToFormat(this.InputFrom.controls['dInvoiceDate'].value, '');
            //UpdateVenodorMaster[0].sVATType = this.InputFrom.controls['sVATType'].value;
            //UpdateVenodorMaster[0].sCurrency = this.InputFrom.controls['sCurrency'].value;
            //UpdateVenodorMaster[0].nExcludeVAT = this.System._ParseFloatToNull(this.InputFrom.controls['nExcludeVAT'].value);
            //UpdateVenodorMaster[0].nVAT = this.System._ParseFloatToNull(this.InputFrom.controls['nVAT'].value);
            //UpdateVenodorMaster[0].nIncludeVAT = this.System._ParseFloatToNull(this.InputFrom.controls['nIncludeVAT'].value);
            //UpdateVenodorMaster[0].sWHTCode = this.InputFrom.controls['sWHTCode'].value;
            //UpdateVenodorMaster[0].nWHTRate = this.System._ParseFloatToNull(this.InputFrom.controls['nWHTRate'].value);
            //UpdateVenodorMaster[0].nWHTVal = this.System._ParseFloatToNull(this.InputFrom.controls['nWHTVal'].value);

            UpdateVenodorMaster[0].nInvoiceType = this.InputFrom.controls['nInvoiceType'].value;
          }
          else {
            this._ArrVendor.push({
              IsVendorOneTime: this.IsVendorOneTime,
              nRowVendor: 1,
              sRequestID: this.sRequestID,
              nItemNo: null,
              cVenderMaster: "M",
              sVendorCode: this.InputFrom.controls['sVendorCode'].value,
              sVendorName: this.InputFrom.controls['sVendorName'].value,
              sTAXID: this.InputFrom.controls['sTAXID'].value,
              nOfficeType: this.InputFrom.controls['nOfficeType'].value,
              sVendorBranch: this.System._ParseString(this.InputFrom.controls['sVendorBranch'].value),
              sVendorAddress: this.InputFrom.controls['sVendorAddress'].value,

              sCountryID: this.InputFrom.controls['sCountryID'].value,
              sProvCode: this.InputFrom.controls['sProvCode'].value,
              sAmpCode: this.InputFrom.controls['sAmpCode'].value,
              sTumbonCode: this.InputFrom.controls['sTumbonCode'].value,
              sPostCode: this.InputFrom.controls['sPostCode'].value,
              sPhoneNumber: this.InputFrom.controls['sPhoneNumber'].value,
              sFaxNumber: this.InputFrom.controls['sFaxNumber'].value,
              sEmail: this.InputFrom.controls['sVendorEmail'].value,

              //เอาส่วน Invoice ออกเเพราะมีผลต่อการคำนวน
              //sInvoiceNo: this.InputFrom.controls['sInvoiceNo'].value,
              //dInvoiceDate: this.InputFrom.controls['dInvoiceDate'].value,
              //sInvoiceDate: this.System._ParseDateToFormat(this.InputFrom.controls['dInvoiceDate'].value, ''),
              //sVATType: this.InputFrom.controls['sVATType'].value,
              //sCurrency: this.InputFrom.controls['sCurrency'].value,
              //nExcludeVAT: this.System._ParseFloatToNull(this.InputFrom.controls['nExcludeVAT'].value),
              //nVAT: this.System._ParseFloatToNull(this.InputFrom.controls['nVAT'].value),
              //nIncludeVAT: this.System._ParseFloatToNull(this.InputFrom.controls['nIncludeVAT'].value),
              //sWHTCode: this.InputFrom.controls['sWHTCode'].value,
              //nWHTRate: this.System._ParseFloatToNull(this.InputFrom.controls['nWHTRate'].value),
              //nWHTVal: this.System._ParseFloatToNull(this.InputFrom.controls['nWHTVal'].value),

              nInvoiceType: this.InputFrom.controls['nInvoiceType'].value,
              IsDelete: false
            });
          }
          //#endregion
          //#region cVenderMaster = N
          let UpdateVenodorSub = this._ArrVendor.filter(w => w.nRowVendor == nRowVendor && w.cVenderMaster == "N" && w.IsDelete == false);
          if (UpdateVenodorSub.length > 0) {//ถ้ามีข้อมูลให้อัพเดท
            UpdateVenodorSub[0].IsVendorOneTime = this.IsVendorOneTime2;
            UpdateVenodorSub[0].sVendorCode = this.InputFrom.controls['sVendorCode2'].value;
            UpdateVenodorSub[0].sVendorName = this.InputFrom.controls['sVendorName2'].value;
            UpdateVenodorSub[0].sTAXID = this.InputFrom.controls['sTAXID2'].value;
            UpdateVenodorSub[0].nOfficeType = this.InputFrom.controls['nOfficeType2'].value;
            UpdateVenodorSub[0].sVendorBranch = this.InputFrom.controls['sVendorBranch2'].value;
            UpdateVenodorSub[0].sVendorAddress = this.InputFrom.controls['sVendorAddress2'].value;

            UpdateVenodorSub[0].sCountryID = this.InputFrom.controls['sCountryID2'].value;
            UpdateVenodorSub[0].sCountryName = this.InputFrom.controls['sCountryName2'].value;
            UpdateVenodorSub[0].sProvCode = this.InputFrom.controls['sProvCode2'].value;
            UpdateVenodorSub[0].sProvName = this.InputFrom.controls['sProvName2'].value;
            UpdateVenodorSub[0].sAmpCode = this.InputFrom.controls['sAmpCode2'].value;
            UpdateVenodorSub[0].sAmpName = this.InputFrom.controls['sAmpName2'].value;
            UpdateVenodorSub[0].sTumbonCode = this.InputFrom.controls['sTumbonCode2'].value;
            UpdateVenodorSub[0].sTumbonName = this.InputFrom.controls['sTumbonName2'].value;
            UpdateVenodorSub[0].sPostCode = this.InputFrom.controls['sPostCode2'].value;
            UpdateVenodorSub[0].sPhoneNumber = this.InputFrom.controls['sPhoneNumber2'].value;
            UpdateVenodorSub[0].sFaxNumber = this.InputFrom.controls['sFaxNumber2'].value;
            UpdateVenodorSub[0].sEmail = this.InputFrom.controls['sVendorEmail2'].value;
            UpdateVenodorSub[0].sAddressOneTime = this.InputFrom.controls['sAddressOneTime2'].value;

            UpdateVenodorSub[0].sInvoiceNo = this.InputFrom.controls['sInvoiceNo'].value;
            UpdateVenodorSub[0].dInvoiceDate = this.InputFrom.controls['dInvoiceDate'].value;
            UpdateVenodorSub[0].sInvoiceDate = this.System._ParseDateToFormat(this.InputFrom.controls['dInvoiceDate'].value, '');
            UpdateVenodorSub[0].sVATType = this.InputFrom.controls['sVATType'].value;
            UpdateVenodorSub[0].sCurrency = this.InputFrom.controls['sCurrency'].value;
            UpdateVenodorSub[0].nExcludeVAT = this.System._ParseFloatToNull(this.InputFrom.controls['nExcludeVAT'].value);
            UpdateVenodorSub[0].nVAT = this.System._ParseFloatToNull(this.InputFrom.controls['nVAT'].value);
            UpdateVenodorSub[0].nIncludeVAT = this.System._ParseFloatToNull(this.InputFrom.controls['nIncludeVAT'].value);
            UpdateVenodorSub[0].nWHTID = this.System.ParseIntToNull(this.InputFrom.controls['nWHTID'].value);
            UpdateVenodorSub[0].nWHTID2 = this.System.ParseIntToNull(this.InputFrom.controls['nWHTID2'].value);
            UpdateVenodorSub[0].nWHTRate = this.System._ParseFloatToNull(this.InputFrom.controls['nWHTRate'].value);
            UpdateVenodorSub[0].nWHTRate2 = this.System._ParseFloatToNull(this.InputFrom.controls['nWHTRate2'].value);
            UpdateVenodorSub[0].nWHTVal = this.System._ParseFloatToNull(this.InputFrom.controls['nWHTVal'].value);
            UpdateVenodorSub[0].nWHTVal2 = this.System._ParseFloatToNull(this.InputFrom.controls['nWHTVal2'].value);
            UpdateVenodorSub[0].nWHTBase = this.System._ParseFloatToNull(this.InputFrom.controls['nWHTBase'].value);
            UpdateVenodorSub[0].nWHTBase2 = this.System._ParseFloatToNull(this.InputFrom.controls['nWHTBase2'].value);
            
            UpdateVenodorSub[0].nInvoiceType = this.InputFrom.controls['nInvoiceType'].value;
          }
          else {//ถ้าไม่มีข้อมูลจะเพิ่ม
            nRowVendor = this._ArrVendor.length + 1;
            this._ArrVendor.push({
              IsVendorOneTime: this.IsVendorOneTime2,
              nRowVendor: nRowVendor,
              sRequestID: this.sRequestID,
              nItemNo: null,
              cVenderMaster: "N",
              sVendorCode: this.InputFrom.controls['sVendorCode2'].value,
              sVendorName: this.InputFrom.controls['sVendorName2'].value,
              sTAXID: this.InputFrom.controls['sTAXID2'].value,
              nOfficeType: this.InputFrom.controls['nOfficeType2'].value,
              sVendorBranch: this.InputFrom.controls['sVendorBranch2'].value,
              sVendorAddress: this.InputFrom.controls['sVendorAddress2'].value,

              sCountryID: this.InputFrom.controls['sCountryID2'].value,
              sCountryName: this.InputFrom.controls['sCountryName2'].value,
              sProvCode: this.InputFrom.controls['sProvCode2'].value,
              sProvName: this.InputFrom.controls['sProvName2'].value,
              sAmpCode: this.InputFrom.controls['sAmpCode2'].value,
              sAmpName: this.InputFrom.controls['sAmpName2'].value,
              sTumbonCode: this.InputFrom.controls['sTumbonCode2'].value,
              sTumbonName: this.InputFrom.controls['sTumbonName2'].value,
              sPostCode: this.InputFrom.controls['sPostCode2'].value,
              sPhoneNumber: this.InputFrom.controls['sPhoneNumber2'].value,
              sFaxNumber: this.InputFrom.controls['sFaxNumber2'].value,
              sEmail: this.InputFrom.controls['sVendorEmail2'].value,
              sAddressOneTime: this.InputFrom.controls['sAddressOneTime2'].value,

              sInvoiceNo: this.InputFrom.controls['sInvoiceNo'].value,
              dInvoiceDate: this.InputFrom.controls['dInvoiceDate'].value,
              sInvoiceDate: this.System._ParseDateToFormat(this.InputFrom.controls['dInvoiceDate'].value, ''),
              sVATType: this.InputFrom.controls['sVATType'].value,
              sCurrency: this.InputFrom.controls['sCurrency'].value,
              nExcludeVAT: this.System._ParseFloatToNull(this.InputFrom.controls['nExcludeVAT'].value),
              nVAT: this.System._ParseFloatToNull(this.InputFrom.controls['nVAT'].value),
              nIncludeVAT: this.System._ParseFloatToNull(this.InputFrom.controls['nIncludeVAT'].value),
              nWHTID: this.System.ParseIntToNull(this.InputFrom.controls['nWHTID'].value),
              nWHTID2: this.System.ParseIntToNull(this.InputFrom.controls['nWHTID2'].value),
              nWHTRate: this.System._ParseFloatToNull(this.InputFrom.controls['nWHTRate'].value),
              nWHTRate2: this.System._ParseFloatToNull(this.InputFrom.controls['nWHTRate2'].value),
              nWHTVal: this.System._ParseFloatToNull(this.InputFrom.controls['nWHTVal'].value),
              _nWHTVal: this.System._ParseFloatToNull(this.InputFrom.controls['nWHTVal'].value),
              nWHTVal2: this.System._ParseFloatToNull(this.InputFrom.controls['nWHTVal2'].value),
              _nWHTVal2: this.System._ParseFloatToNull(this.InputFrom.controls['nWHTVal2'].value),
              nWHTBase: this.System._ParseFloatToNull(this.InputFrom.controls['nWHTBase'].value),
              nWHTBase2: this.System._ParseFloatToNull(this.InputFrom.controls['nWHTBase2'].value),
              nInvoiceType: this.InputFrom.controls['nInvoiceType'].value,
              IsDelete: false
            });
          }
          //#endregion
          //#region GL
          for (var i = 0; i < this.ArrGL.length; i++) {
            let Isdelete = this.ArrGL.value[i].IsDelete;
            let _nRowVendorInvoice = this.ArrGL.value[i].nRowVendorInvoice;
            if (!Isdelete) {//ไม่นำรายการที่ ลบมาอัพเดท
              let nRowVendorInvoice = this._ArrVendorInvoice.length + 1;
              let UpdateVenodrInvoice = this._ArrVendorInvoice.filter(w => w.nRowVendor == this.InvoiceEdit && w.nRowVendorInvoice == _nRowVendorInvoice);
              if (UpdateVenodrInvoice.length == 0) {
                this._ArrVendorInvoice.push({
                  nRowVendor: nRowVendor,
                  nRowVendorInvoice: nRowVendorInvoice,
                  sRequestID: this.sRequestID,
                  nItemNo: this.ArrGL.value[i].nItemNo,
                  nLineNo: this.ArrGL.value[i].nLineNo,
                  sInvoiceNo: this.InputFrom.controls['sInvoiceNo'].value,
                  dInvoiceDate: this.InputFrom.controls['dInvoiceDate'].value,
                  sVATType: this.InputFrom.controls['sVATType'].value,
                  sGL: this.ArrGL.value[i].sGL,
                  sCostCenter: this.ArrGL.value[i].sCostCenter,
                  sText: this.ArrGL.value[i].sText,
                  sIO: this.ArrGL.value[i].sIO === "Not Require IO (N/A)" ? null : this.ArrGL.value[i].sIO,
                  nAmtExcldVAT: this.System._ParseFloatToNull(this.ArrGL.value[i].sAmountExcludedVAT),
                  sCurrency: this.InputFrom.controls['sCurrency'].value,
                  cActive: "Y",
                  IsDelete: false
                })
                this.ArrGL.value[i].nRowVendor = nRowVendor;
                this.ArrGL.value[i].nRowVendorInvoice = nRowVendorInvoice;
              }
              else {
                UpdateVenodrInvoice[0].sInvoiceNo = this.InputFrom.controls['sInvoiceNo'].value;
                UpdateVenodrInvoice[0].dInvoiceDate = this.InputFrom.controls['dInvoiceDate'].value;
                UpdateVenodrInvoice[0].sVATType = this.InputFrom.controls['sVATType'].value;
                UpdateVenodrInvoice[0].sGL = this.ArrGL.value[i].sGL;
                UpdateVenodrInvoice[0].sCostCenter = this.ArrGL.value[i].sCostCenter;
                UpdateVenodrInvoice[0].sText = this.ArrGL.value[i].sText;
                UpdateVenodrInvoice[0].sIO = this.ArrGL.value[i].sIO === "Not Require IO (N/A)" ? null : this.ArrGL.value[i].sIO;
                UpdateVenodrInvoice[0].nAmtExcldVAT = this.System._ParseFloatToNull(this.ArrGL.value[i].sAmountExcludedVAT);
                UpdateVenodrInvoice[0].sCurrency = this.InputFrom.controls['sCurrency'].value;
                UpdateVenodrInvoice[0].cActive = "Y";
                UpdateVenodrInvoice[0].IsDelete = false;
              }
            }
          }
          //#endregion
          this.ClearFromInvoiceAfterSave();
          this.InvoiceEdit = null;

          //#region 2021-01-21 Log Save Invoice
          let _Data = {
            //Section 1
            sRequestID: this.System._ParseString(this.sRequestID),
            TRequestItems: this._ArrVendor,
            TRequestLineItems: this._ArrVendorInvoice,
          }
          let ITEM = JSON.stringify(_Data);
          const options = { headers: { 'Content-Type': 'application/json' } };
          this.http.post<any>(this.System.SiteName + "api/ClearAdvance/LogInvoice", _Data, options).subscribe(res => { })
          //#endregion
        }
        else {
          this.swal.SwAlert.Error(this.swal.BoxMsg.Title_Error, this.swal.BoxMsg.Desc_Specify_AddInvoice, function () { Swal.close(); });
        }
        this.CalCulateGrand();
        this.CheckCurrency();
      }
      else {

        this.swal.SwAlert.Error(this.swal.BoxMsg.Title_Error, _CheckDup.Msg, function () { Swal.close(); });
      }
    }
    else {
      var elmnt = document.getElementById("DIV_Section2").querySelectorAll(".has-error");
      if (elmnt.length > 0) {
        elmnt[0].scrollIntoView();
      }
    }

    this.GL_NoData = this._ArrVendorInvoice.filter(w => w.IsDelete == false).length > 0 ? false : true;
    this.System.UnBlockUI();
  }
  EditInvoice(_Item) {
    this.System.BlockUI();
    let _Form = this.InputFrom;
    this.InvoiceEdit = _Item.nRowVendor;
    let VendorItemMaster = this._ArrVendor.filter(w => w.cVenderMaster == "M" && w.IsDelete == false);//w.nRowVendor == 1 &&
    let VendorItemSub = this._ArrVendor.filter(w => w.nRowVendor == this.InvoiceEdit && w.cVenderMaster == "N" && w.IsDelete == false);
    let VendorGLItem = this._ArrVendorInvoice.filter(w => w.nRowVendor == this.InvoiceEdit);

    var elmnt = document.getElementById("DIV_Section2");
    elmnt.scrollIntoView();
    //Vendor
    if (VendorItemSub.length > 0) {
      //let IsVendorVat = VendorItemMaster[0].nInvoiceType == 1;
      this.IsVendorOneTime = VendorItemMaster[0].IsVendorOneTime;
      this.IsVendorOneTime2 = VendorItemSub.length > 0 ? VendorItemSub[0].IsVendorOneTime : false;

      let sCountryName = VendorItemSub[0].sCountryName;
      if (!sCountryName) {
        let Country = this._ArrCountry.filter(f => f.sCountryID == VendorItemSub[0].sCountryID);
        if (Country.length > 0) {
          sCountryName = Country[0].sCountryName;
        }
      }


      this.InputFrom.patchValue({
        nInvoiceType: VendorItemSub[0].nInvoiceType,

        sVendorCode: VendorItemMaster[0].sVendorCode,
        sVendorName: VendorItemMaster[0].sVendorName,
        sTAXID: VendorItemMaster[0].sTAXID,
        nOfficeType: VendorItemMaster[0].nOfficeType,
        sVendorBranch: VendorItemMaster[0].sVendorBranch,
        sVendorAddress: VendorItemMaster[0].sVendorAddress,

        sCountryID: this.IsVendorOneTime ? VendorItemMaster[0].sCountryID : "",
        sProvCode: this.IsVendorOneTime ? VendorItemMaster[0].sProvCode : "",
        sAmpCode: this.IsVendorOneTime ? VendorItemMaster[0].sAmpCode : "",
        sTumbonCode: this.IsVendorOneTime ? VendorItemMaster[0].sTumbonCode : "",
        sPostCode: this.IsVendorOneTime ? VendorItemMaster[0].sPostCode : "",
        sPhoneNumber: this.IsVendorOneTime ? VendorItemMaster[0].sPhoneNumber : "",
        sFaxNumber: this.IsVendorOneTime ? VendorItemMaster[0].sFaxNumber : "",
        sVendorEmail: this.IsVendorOneTime ? VendorItemMaster[0].sEmail : "",

        //sVendorCode2: IsVendorVat ? VendorItemSub[0].sVendorCode : "",
        //sVendorName2: IsVendorVat ? VendorItemSub[0].sVendorName : "",
        //sTAXID2: IsVendorVat ? VendorItemSub[0].sTAXID : "",
        //nOfficeType2: IsVendorVat ? VendorItemSub[0].nOfficeType : "",
        //sVendorBranch2: IsVendorVat ? VendorItemSub[0].sVendorBranch : "",
        //sVendorAddress2: IsVendorVat ? VendorItemSub[0].sVendorAddress : "",

        //sCountryID2: IsVendorVat && this.IsVendorOneTime2 ? VendorItemSub[0].sCountryID : "",
        //sProvCode2: IsVendorVat && this.IsVendorOneTime2 ? this.System._ParseString(VendorItemSub[0].sProvCode) : "",
        //sAmpCode2: IsVendorVat && this.IsVendorOneTime2 ? this.System._ParseString(VendorItemSub[0].sAmpCode) : "",
        //sTumbonCode2: IsVendorVat && this.IsVendorOneTime2 ? this.System._ParseString(VendorItemSub[0].sTumbonCode) : "",
        //sPostCode2: IsVendorVat && this.IsVendorOneTime2 ? VendorItemSub[0].sPostCode : "",
        //sPhoneNumber2: IsVendorVat && this.IsVendorOneTime2 ? VendorItemSub[0].sPhoneNumber : "",
        //sFaxNumber2: IsVendorVat && this.IsVendorOneTime2 ? VendorItemSub[0].sFaxNumber : "",
        //sVendorEmail2: IsVendorVat && this.IsVendorOneTime2 ? VendorItemSub[0].sEmail : "",
        //sAddressOneTime2: IsVendorVat && this.IsVendorOneTime2 ? VendorItemSub[0].sAddressOneTime : "",

        sVendorCode2: VendorItemSub[0].sVendorCode,
        sVendorName2: VendorItemSub[0].sVendorName,
        sTAXID2: VendorItemSub[0].sTAXID,
        nOfficeType2: VendorItemSub[0].nOfficeType,
        sVendorBranch2: VendorItemSub[0].sVendorBranch,
        sVendorAddress2: VendorItemSub[0].sVendorAddress,

        sCountryID2: this.IsVendorOneTime2 ? VendorItemSub[0].sCountryID : "",
        sCountryName2: this.IsVendorOneTime2 ? sCountryName : "",
        sProvCode2: this.IsVendorOneTime2 ? this.System._ParseString(VendorItemSub[0].sProvCode) : "",
        sProvName2: this.IsVendorOneTime2 ? this.System._ParseString(VendorItemSub[0].sProvName) : "",
        sAmpCode2: this.IsVendorOneTime2 ? this.System._ParseString(VendorItemSub[0].sAmpCode) : "",
        sAmpName2: this.IsVendorOneTime2 ? this.System._ParseString(VendorItemSub[0].sAmpName) : "",
        sTumbonCode2: this.IsVendorOneTime2 ? this.System._ParseString(VendorItemSub[0].sTumbonCode) : "",
        sTumbonName2: this.IsVendorOneTime2 ? this.System._ParseString(VendorItemSub[0].sTumbonName) : "",
        sPostCode2: this.IsVendorOneTime2 ? VendorItemSub[0].sPostCode : "",
        sPhoneNumber2: this.IsVendorOneTime2 ? VendorItemSub[0].sPhoneNumber : "",
        sFaxNumber2: this.IsVendorOneTime2 ? VendorItemSub[0].sFaxNumber : "",
        sVendorEmail2: this.IsVendorOneTime2 ? VendorItemSub[0].sEmail : "",
        sAddressOneTime2: this.IsVendorOneTime2 ? VendorItemSub[0].sAddressOneTime : "",

        sInvoiceNo: VendorItemSub[0].sInvoiceNo,
        dInvoiceDate: this.System._ParseDateToNull(VendorItemSub[0].sInvoiceDate),
        sVATType: VendorItemSub[0].sVATType,
        sCurrency: VendorItemSub[0].sCurrency,
        nExcludeVAT: this.System._ParseToDecimal(VendorItemSub[0].nExcludeVAT),
        nVAT: this.System._ParseToDecimal(VendorItemSub[0].nVAT),
        nIncludeVAT: this.System._ParseToDecimal(VendorItemSub[0].nIncludeVAT),
        nWHTID: this.System._ParseString(VendorItemSub[0].nWHTID + ""),
        nWHTID2: this.System._ParseString(VendorItemSub[0].nWHTID2 + ""),
        nWHTRate: VendorItemSub[0].nWHTID == 99 || VendorItemSub[0].nWHTID == 6 ? this.System._ParseToDecimal(VendorItemSub[0].nWHTRate) : null,
        nWHTRate2: VendorItemSub[0].nWHTID2 == 99 || VendorItemSub[0].nWHTID2 == 6 ? this.System._ParseToDecimal(VendorItemSub[0].nWHTRate2) : null,
        nWHTVal: this.System._ParseToDecimal(VendorItemSub[0].nWHTVal),
        _nWHTVal: this.System._ParseToDecimal(VendorItemSub[0].nWHTVal),
        nWHTVal2: this.System._ParseToDecimal(VendorItemSub[0].nWHTVal2),
        _nWHTVal2: this.System._ParseToDecimal(VendorItemSub[0].nWHTVal2),
        nWHTBase: this.System._ParseToDecimal(VendorItemSub[0].nWHTBase),
        nWHTBase2: this.System._ParseToDecimal(VendorItemSub[0].nWHTBase2)
      });

      let Invoice = VendorItemSub[0].nInvoiceType;
      switch (Invoice) {
        case 1:
          if (this.PRMS) {
            this.InputFrom.get('sVATType').enable();
            this.InputFrom.get('nVAT').enable();
            this.InputFrom.get("nWHTID").enable();
            this.InputFrom.get("nWHTID2").enable();
          }
          break;
        case 2:
          this.InputFrom.get('sVATType').disable();
          this.InputFrom.get("nVAT").disable();
          this.InputFrom.get("nWHTID").disable();
          this.InputFrom.get("nWHTID2").disable();
          this.IsNotVat = true;
          break;
      }


      if (this.InputFrom.controls['nOfficeType'].value == 1) {
        this.InputFrom.get('sVendorBranch').disable();
      } else {
        if (this.PRMS) {
          this.InputFrom.get('sVendorBranch').enable();
        }
      }

      if (this.InputFrom.controls['nOfficeType2'].value == 1) {
        this.InputFrom.get('sVendorBranch2').disable();
      } else {
        if (this.PRMS) {
          this.InputFrom.get('sVendorBranch2').enable();
        }
      }

      //#region กรณี Vat Type
      this.SetControlVatType(VendorItemSub[0].sVATType);
      //#endregion
      this.OnChangeVat();

      if (VendorItemSub[0].nWHTID + "" === "99" || VendorItemSub[0].nWHTID + "" === "6") {
        if (this.PRMS) {
          this.InputFrom.get('nWHTRate').enable();
        }
      }
      else {
        this.InputFrom.get('nWHTRate').disable();
      }
      if (VendorItemSub[0].nWHTID2 + "" === "99" || VendorItemSub[0].nWHTID2 + "" === "6") {
        if (this.PRMS) {
          this.InputFrom.get('nWHTRate2').enable();
        }
      }
      else {
        this.InputFrom.get('nWHTRate2').disable();
      }

      if (this.IsVendorOneTime2) {
        //this.IsTH2 = VendorItemSub[0].sCountryID + "" == "213";
        //if (this.IsTH2) {
        this.OnChangeProvince(2);
        this.OnChangeDistrict(2);
        //}

        //this.FieldVendorOnetime2.forEach(function (Item) {
        //  _Form.get(Item._Field).markAsUntouched({ onlySelf: true });
        //  _Form.controls[Item._Field].setValue(Item._Value);//Set ค่า
        //  _Form.controls[Item._Field].setValidators(Item._Validator);//กำหนด Validate
        //  _Form.controls[Item._Field].setErrors(null);//ปรับ Control ให้เป็นปกติ
        //  _Form.controls[Item._Field].updateValueAndValidity();//Update Validate
        //});

        _Form.controls["sVendorName2"].enable();
        _Form.controls["sTAXID2"].enable();
        _Form.controls["sVendorAddress2"].enable();

      }
      else {
        this.ClearVendorOneTime2();
        _Form.controls["sVendorName2"].disable();
        _Form.controls["sTAXID2"].disable();
        _Form.controls["sVendorAddress2"].disable();
      }

    }
    this.ArrGL.clear();
    for (let i = 0; i < VendorGLItem.length; i++) {
      this.ArrGL.push(new FormGroup({
        nRowVendor: new FormControl(VendorGLItem[i].nRowVendor),
        nRowVendorInvoice: new FormControl(VendorGLItem[i].nRowVendorInvoice),
        sRequestID: new FormControl(VendorGLItem[i].sRequestID),
        nItemNo: new FormControl(VendorGLItem[i].nItemNo),
        nLineNo: new FormControl(VendorGLItem[i].nLineNo),
        sGL: new FormControl(VendorGLItem[i].sGL, Validators.required),
        sCostCenter: new FormControl(VendorGLItem[i].sCostCenter, Validators.required),
        sText: new FormControl(VendorGLItem[i].sText, Validators.required),
        sIO: new FormControl(VendorGLItem[i].sIO === null ? "Not Require IO (N/A)" : VendorGLItem[i].sIO, Validators.required),
        sAmountExcludedVAT: new FormControl(this.System._ParseToDecimal(VendorGLItem[i].nAmtExcldVAT), Validators.required),
        IsDelete: new FormControl(VendorGLItem[i].IsDelete)
      }));
    }


    this.System.UnBlockUI();
  }
  DeleteInvoice(_Item) {
    let _This = this;
    this.swal.SwAlert.Confirm(this.swal.BoxMsg.Title_Confirm, this.swal.BoxMsg.Desc_Confirm_Delete,
      function () {
        //_This.InvoiceEdit = _Item.nRowVendor;
        let InvoiceEdit = _Item.nRowVendor;

        //ตรวจสอบว่าลบรายการใด
        let VendorGLItem = _This._ArrVendorInvoice.filter(w => w.nRowVendor == InvoiceEdit && w.nRowVendorInvoice == _Item.nRowVendorInvoice && w.IsDelete == false);
        if (VendorGLItem.length > 0) {
          VendorGLItem[0].IsDelete = true;
          VendorGLItem[0].cActive = "N";
        }

        //ตรวจสอบว่าลบรายการ GL ทั้งหมดแล้วหรือไม่ถ้าลบแล้วระบบจะลบ Vendor ออก
        let CheckDeleteAll = _This._ArrVendorInvoice.filter(w => w.nRowVendor == InvoiceEdit && w.IsDelete == false);
        if (CheckDeleteAll.length == 0) {
          let VendorItemMaster = _This._ArrVendor.filter(w => w.nRowVendor == InvoiceEdit && w.cVenderMaster == "M" && w.IsDelete == false);
          if (VendorItemMaster.length > 0) {
            VendorGLItem[0].IsDelete = true;
          }
          let VendorItemSub = _This._ArrVendor.filter(w => w.nRowVendor == InvoiceEdit && w.cVenderMaster == "N" && w.IsDelete == false);
          if (VendorItemSub.length > 0) {
            VendorItemSub[0].IsDelete = true;
          }
        }


        _This.CheckCurrency();
        _This.CalCulateGrand();
        _This.GL_NoData = _This._ArrVendorInvoice.filter(w => w.IsDelete == false).length > 0 ? false : true;
        if (_This.GL_NoData) {
          _This.InputFrom.controls["sCurrency"].setValue("THB");
        }
      },
      function () {
        Swal.close();
      });
  }

  CheckInvoiceValid() {
    let IsValid: boolean = true;
    let _FormGroup = this.InputFrom;
    let This = this;

    this.FieldVendor.forEach(function (Item) {
      if (!_FormGroup.get(Item._Field).valid && !_FormGroup.get(Item._Field).disabled) {
        IsValid = false;
        return false;
      }
    });

    //กรณีเลือก Vendor เป้น Onetime
    if (this.IsVendorOneTime && IsValid) {
      this.FieldVendorOnetime.forEach(function (Item) {
        if (!_FormGroup.get(Item._Field).valid) {
          IsValid = false;
          return false;
        }
      });
    }

    //กรณีเลือกเป้น Vat Or WHT ระบบจะเช็ค Vendor2
    if (!This.IsNotVat) {//กรณีเลือกเป็น No Vat ระบบจะไม่เช็คขา Vendor
      if (IsValid) {
        this.FieldVendor2.forEach(function (Item) {
          if (!_FormGroup.get(Item._Field).valid && !_FormGroup.get(Item._Field).disabled) {
            IsValid = false;
            return false;
          }
        });

        //กรณีเลือก Vendor2 เป้น Onetime
        if (this.IsVendorOneTime2 && IsValid) {
          this.FieldVendorOnetime2.forEach(function (Item) {
            if (!_FormGroup.get(Item._Field).valid) {
              IsValid = false;
              return false;
            }
          });
        }
      }
    }

    if (IsValid) {
      this.FieldInvoice.forEach(function (Item) {
        if (!_FormGroup.get(Item._Field).valid && !_FormGroup.get(Item._Field).disabled) {
          IsValid = false;
          return false;
        }
      });
    }

    //เช็ค ArrGL
    if (IsValid) {
      for (let i = 0; i < this.ArrGL.length; i++) {
        if (!this.ArrGL.value[i].IsDelete) {
          this.FieldGLValid.forEach(function (Field) {
            let FromArray = _FormGroup.get('ArrGL') as FormArray;
            if (Field == "sIO" && This.IsNotFill_IO) {

            }
            else if (Field == "sGL" && This.IsNotFill_GL) {

            }
            else {
              if (!FromArray.at(i).get(Field).valid && !FromArray.at(i).get(Field).disabled) {
                IsValid = false;
                return false;
              }
            }
          });
        }
      }
    }

    //ถ้าไม่ผ่านให้ระบบทำการแสดง Validate
    if (!IsValid) {
      this.FieldVendor.forEach(function (Item) {
        if (!_FormGroup.get(Item._Field).disabled) {
          const control = _FormGroup.get(Item._Field);
          if (control instanceof FormControl) {
            control.markAsTouched({ onlySelf: true });
          }
        }
      });

      if (this.IsVendorOneTime) {
        this.FieldVendorOnetime.forEach(function (Item) {
          const control = _FormGroup.get(Item._Field);
          if (control instanceof FormControl) {
            control.markAsTouched({ onlySelf: true });
          }
        });
      }

      if (!This.IsNotVat) {//กรณีเลือกเป็น No Vat ระบบจะไม่เช็คขา Vendor
        this.FieldVendor2.forEach(function (Item) {
          if (!_FormGroup.get(Item._Field).disabled) {
            const control = _FormGroup.get(Item._Field);
            if (control instanceof FormControl) {
              control.markAsTouched({ onlySelf: true });
            }
          }
        });

        if (this.IsVendorOneTime2) {
          this.FieldVendorOnetime2.forEach(function (Item) {
            const control = _FormGroup.get(Item._Field);
            if (control instanceof FormControl) {
              control.markAsTouched({ onlySelf: true });
            }
          });
        }
      }

      this.FieldInvoice.forEach(function (Item) {
        if (!_FormGroup.get(Item._Field).disabled) {
          const control = _FormGroup.get(Item._Field);
          if (control instanceof FormControl) {
            control.markAsTouched({ onlySelf: true });
          }
        }
      });

      for (let i = 0; i < this.ArrGL.length; i++) {
        this.FieldGLValid.forEach(function (Field) {
          let FromArray = _FormGroup.get('ArrGL') as FormArray;
          const control = FromArray.at(i).get(Field);

          if (control instanceof FormControl) {
            if (This.IsNotFill_IO && Field == "sIO") {//IsNotFill_IO คือระบบไม่ต้องกรอก IO

            }
            if (This.IsNotFill_GL && Field == "sGL") {//IsNotFill_GL คือระบบไม่ต้องกรอก GL

            }
            else {
              control.markAsTouched({ onlySelf: true });
            }
          }

        });
      }
    }

    return IsValid;
  }
  async  CheckDuplicateData() {
    let Result = { IsPass: true, Msg: "" };
    let sInvoiceNo = this.InputFrom.controls["sInvoiceNo"].value;
    //let VendorItemSub = this._ArrVendor.filter(w => w.nRowVendor == this.InvoiceEdit && w.cVenderMaster == "N" && w.IsDelete == false);
    //if (VendorItemSub.length > 0) {
    //  sInvoiceNo = VendorItemSub[0].sInvoiceNo;
    //}
    //Case 1 เช็คจาก Database
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),

      params: new HttpParams()
        .set("sRequestID", this.sRequestID)
        .set("sInvoiceNo", sInvoiceNo)
        .set("sInvoiceDate", this.System._FormatDate(this.InputFrom.controls['dInvoiceDate'].value))
        .set("sCompCode", this.InputFrom.controls['sCompCode'].value)
    };
    const res = await this.http.get<any>(this.System.SiteName + "api/_System/CheckDuplicateInvoice", httpOptions).toPromise();
    if (res) {
      if (res.length > 0) {
        Result.IsPass = false;
        Result.Msg = this.swal.BoxMsg.Desc_Receipt_Duplicate;
      }
      else {
        Result.IsPass = true;
      }
    }
    else {
      Result.IsPass = true;
    }

    //Case 2 เช็คจาก Array
    if (Result.IsPass) {
      let DupInvoice = this._ArrVendor.filter(w => w.sInvoiceNo == this.InputFrom.controls['sInvoiceNo'].value
        && this.System._FormatDate(w.dInvoiceDate) == this.System._FormatDate(this.InputFrom.controls['dInvoiceDate'].value)
        && w.IsDelete == false
        && (this.InvoiceEdit == null ? true : (w.nRowVendor != this.InvoiceEdit))//ตรวจสอบว่า InvoiceEdit มีค่าไหมถ้าไม่มีระบบจะไม่สนใจเงื่อนไขนี้ แต่ถ้ามีจะหาตัวที่ไม่เท่ากับ nRowVendor ที่กด Edit มา
      );
      if (DupInvoice.length > 0) {
        Result.IsPass = false;
        Result.Msg = this.swal.BoxMsg.Desc_Receipt_Duplicate;;
      }
    }

    if (Result.IsPass) {
      let nTotalInvoice = this.System._ParseFloatToZero(this.InputFrom.controls["nExcludeVAT"].value);
      let nTotalGL = 0;
      for (let i = 0; i < this.ArrGL.length; i++) {
        if (!this.ArrGL.value[i].IsDelete) {
          nTotalGL += this.System._ParseFloatToZero(this.ArrGL.value[i].sAmountExcludedVAT);
        }
      }

      //แก้ให้เป็น ทศนิยม 2 ตำแน่ง
      nTotalInvoice = this.System._ParseFloatToZero(nTotalInvoice.toFixed(2));
      nTotalGL = this.System._ParseFloatToZero(nTotalGL.toFixed(2));

      if (nTotalInvoice != nTotalGL) {
        Result.IsPass = false;
        Result.Msg = this.swal.BoxMsg.Desc_Invoice_TotalNoMatch;
      }
    }

    return Result;
  }
  CheckCurrency() {
    let CHK_Invoice = this._ArrVendorInvoice.filter(w => w.IsDelete == false);
    // if (CHK_Invoice.length > 0) {
    //   this.InputFrom.get('sCurrency').disable();
    // }
    // else {
    //   this.InputFrom.get('sCurrency').enable();
    // }
    this.InputFrom.get('sCurrency').enable();
  }

  ClearVendor() {
    let _Form = this.InputFrom;
    this.FieldVendor.forEach(function (Item) {
      _Form.get(Item._Field).markAsUntouched({ onlySelf: true });
      _Form.controls[Item._Field].setValue(Item._Value);//Set ค่า
      _Form.controls[Item._Field].setValidators(Item._Validator);//กำหนด Validate
      _Form.controls[Item._Field].setErrors(null);//ปรับ Control ให้เป็นปกติ
      _Form.controls[Item._Field].updateValueAndValidity();//Update Validate
    });
    _Form.controls["sVendorBranch"].disable();
  }
  ClearVendorOneTime() {
    let _Form = this.InputFrom;
    this.FieldVendorOnetime.forEach(function (Item) {
      _Form.controls[Item._Field].setValue("");
      _Form.controls[Item._Field].setErrors(null);
      _Form.controls[Item._Field].clearValidators();
    });
    this.IsVendorOneTime = false;
  }
  ClearVendor2() {
    let _Form = this.InputFrom;
    this.FieldVendor2.forEach(function (Item) {
      _Form.get(Item._Field).markAsUntouched({ onlySelf: true });
      _Form.controls[Item._Field].setValue(Item._Value);//Set ค่า
      _Form.controls[Item._Field].setValidators(Item._Validator);//กำหนด Validate
      _Form.controls[Item._Field].setErrors(null);//ปรับ Control ให้เป็นปกติ
      _Form.controls[Item._Field].updateValueAndValidity();//Update Validate
    });
    _Form.controls["sVendorBranch2"].disable();
  }
  ClearVendorOneTime2() {
    let _Form = this.InputFrom;
    this.FieldVendorOnetime2.forEach(function (Item) {
      _Form.controls[Item._Field].setValue("");
      _Form.controls[Item._Field].setErrors(null);
      _Form.controls[Item._Field].clearValidators();
    });
    this.IsVendorOneTime2 = false;
  }
  ValidateVendorOneTime2(Setvalid) {
    let _Form = this.InputFrom;
    this.FieldVendorOnetime2.forEach(function (Item) {
      if (Setvalid) {
        _Form.get(Item._Field).markAsUntouched({ onlySelf: true });
        _Form.controls[Item._Field].setValue(Item._Value);//Set ค่า
        _Form.controls[Item._Field].setValidators(Item._Validator);//กำหนด Validate
        _Form.controls[Item._Field].setErrors(null);//ปรับ Control ให้เป็นปกติ
        _Form.controls[Item._Field].updateValueAndValidity();//Update Validate
      }
      else {
        _Form.controls[Item._Field].setValue("");
        _Form.controls[Item._Field].setErrors(null);
        _Form.controls[Item._Field].clearValidators();
      }
    });
  }
  ClearInvoice() {
    let _Form = this.InputFrom;
    this.FieldInvoice.forEach(function (Item) {
      _Form.get(Item._Field).markAsUntouched({ onlySelf: true });
      if (Item._Field != "sCurrency") {//ไม่ต้องเคลียกรณี Currency
        _Form.controls[Item._Field].setValue(Item._Value);//Set ค่า
      }
      _Form.controls[Item._Field].setValidators(Item._Validator);//กำหนด Validate
      _Form.controls[Item._Field].setErrors(null);//ปรับ Control ให้เป็นปกติ
      _Form.controls[Item._Field].updateValueAndValidity();//Update Validate
    });
    _Form.controls["nWHTRate"].disable();
    _Form.controls["nWHTRate2"].disable();
  }
  ClearInVoiceGL() {
    this.ArrGL.clear();
    this.ArrGL.push(new FormGroup({
      nRowVendor: new FormControl(null),
      nRowVendorInvoice: new FormControl(null),
      sRequestID: new FormControl(''),
      nItemNo: new FormControl(null),
      nLineNo: new FormControl(null),
      sGL: new FormControl('', Validators.required),
      sCostCenter: new FormControl('', Validators.required),
      sText: new FormControl('', Validators.required),
      sIO: new FormControl('', Validators.required),
      sAmountExcludedVAT: new FormControl('', Validators.required),
      IsDelete: new FormControl(false)
    }));
    // this._ArrVendorIO.push([]);
  }

  ClearFromInvoiceAfterSave() {
    this.ClearInvoice();
    this.ClearInVoiceGL();
    //Check เพิ่มเติมตาม VatType
    this.OnChangeReceiptType();


  }
  ClearFromInvoice() {//เคลียฟอม InVoice หลัก
    //this.ClearVendor();
    //this.IsVendorOneTime = false;
    //this.ClearVendorOneTime();
    this.ClearVendor2();
    this.IsVendorOneTime2 = false;
    this.ClearVendorOneTime2();
    this.ClearInvoice();
    this.ClearInVoiceGL();

    this.InputFrom.patchValue({ nInvoiceType: 1 });
    this.OnChangeReceiptType();
    this.InvoiceEdit = null;

    if (!this.PRMS) {
      this.InputFrom.controls["sVATType"].disable();
      this.InputFrom.controls["nVAT"].disable();
    }
  }

  CalculateWHT(mode: number, byTotal) {
    let _total = this.System._ParseFloatToZero(this.InputFrom.controls['nExcludeVAT'].value);
    if (mode === 1) {
      let WHTBase = '0.00';
      let _WHTRate = this.GetWHTRate(this.InputFrom.controls["nWHTID"].value);

      if (this.InputFrom.value['nWHTID']) {
        let _WHTBase = this.System._ParseFloatToZero(this.InputFrom.controls['nWHTBase'].value);
        if (!byTotal && _WHTBase > 0) _total = _WHTBase;
        WHTBase = this.System._ParseToDecimal(_total);
    }

      let _nWHTVal = _total * _WHTRate;
      this.InputFrom.patchValue({ nWHTBase: WHTBase, nWHTVal: this.System._ParseToDecimal(_nWHTVal), _nWHTVal: this.System._ParseToDecimal(_nWHTVal)});
    }
    else{
      let WHTBase2 = '0.00';
      let _WHTRate2 = this.GetWHTRate2(this.InputFrom.controls["nWHTID2"].value);
      _total = this.System._ParseFloatToZero(this.InputFrom.controls['nWHTBase2'].value);

      if (this.InputFrom.value['nWHTID2']) {
        WHTBase2 = this.System._ParseToDecimal(_total);
      }

      let _nWHTVal2 = _total * _WHTRate2;
      this.InputFrom.patchValue({ nWHTBase2: WHTBase2, nWHTVal2: this.System._ParseToDecimal(_nWHTVal2), _nWHTVal2: this.System._ParseToDecimal(_nWHTVal2) });
    }
  }

  GetWHTRate(sWHTCode) {
    let _WHTRate: any = 0.00;
    if (sWHTCode == "99" || sWHTCode == "6") {
      if (this.InputFrom.controls['nWHTRate'].value != 0 && this.InputFrom.controls['nWHTRate'].value != null) {
        _WHTRate = this.System._ParseFloatToZero(this.InputFrom.controls['nWHTRate'].value) / 100.00;
      }
    }
    else {
      let _DataWHT = this._WithholdingTax.filter(w => w.WHTCode + "" == sWHTCode + "");
      if (_DataWHT.length > 0) {
        if (_DataWHT[0].WHTRate != 0 && _DataWHT[0].WHTRate != null) {
          _WHTRate = this.System._ParseFloatToZero(_DataWHT[0].WHTRate + "") / 100.00;
        }
      }
    }
    return _WHTRate;
  }
  GetWHTRate2(sWHTCode2) {
    let _WHTRate2: any = 0.00;
    if (sWHTCode2 == "99" || sWHTCode2 == "6") {
      if (this.InputFrom.controls['nWHTRate2'].value != 0 && this.InputFrom.controls['nWHTRate2'].value != null) {
        _WHTRate2 = this.System._ParseFloatToZero(this.InputFrom.controls['nWHTRate2'].value) / 100.00;
      }
    }
    else {
      let _DataWHT2 = this._WithholdingTax.filter(w => w.WHTCode + "" == sWHTCode2 + "");
      if (_DataWHT2.length > 0) {
        if (_DataWHT2[0].WHTRate != 0 && _DataWHT2[0].WHTRate != null) {
          _WHTRate2 = this.System._ParseFloatToZero(_DataWHT2[0].WHTRate + "") / 100.00;
        }
      }
    }
    return _WHTRate2;
  }
  GetVatRate(sVatCode) {
    let _VatRate: any = 0.00;
    let _Data = this._VatType.filter(w => w.TAX_CODE == sVatCode);
    if (_Data.length > 0) {
      _VatRate = _Data[0].nVAT;
    }
    return _VatRate;
  }
  CalculateInVoice(byTotal) {
    let VatType = this.InputFrom.controls['sVATType'].value;
    let Taxvat = this._VatType.filter(data => data.TAX_CODE == VatType);
    let nvat = Taxvat.map(re => re.nVAT)[0];
    if (nvat == null) {//กรณี Vat ไม่มีค่าระบบจะนำไปล็อกและตัดเป็น null
      this.InputFrom.get("nVAT").disable();
      this.InputFrom.get("nVAT").markAsUntouched({ onlySelf: true });
      this.InputFrom.controls["nVAT"].setValue(null);//Set ค่า
      this.InputFrom.controls["nVAT"].setErrors(null);//ปรับ Control ให้เป็นปกติ
      this.InputFrom.controls["nVAT"].clearValidators();//Update Validate
      if (this.InputFrom.controls['nExcludeVAT'].value) {
        let TotalExcludeVAT = this.System._ParseFloatToZero(this.InputFrom.controls['nExcludeVAT'].value);
        this.InputFrom.patchValue({
          nIncludeVAT: this.System._ParseToDecimal(TotalExcludeVAT),
          nVAT: null,
          nExcludeVAT: this.System._ParseToDecimal(TotalExcludeVAT)
        })
      }
    }
    else { //กรณี Vat มีค่าระบบจะนำไปคำนวน
      this.InputFrom.get('nVAT').enable();
      this.InputFrom.get("nVAT").markAsUntouched({ onlySelf: true });
      this.InputFrom.controls["nVAT"].setValidators(Validators.required);//กำหนด Validate
      this.InputFrom.controls["nVAT"].setErrors(null);//ปรับ Control ให้เป็นปกติ
      this.InputFrom.controls["nVAT"].updateValueAndValidity();//Update Validate
      if (this.InputFrom.controls['nExcludeVAT'].value) {
        let TotalExcludeVAT = this.System._ParseFloatToZero(this.InputFrom.controls['nExcludeVAT'].value);
        let vat = TotalExcludeVAT * this.System._ParseFloatToZero(nvat); //
        let TotalIncludeVAT = (TotalExcludeVAT + vat);
        this.InputFrom.patchValue({
          nIncludeVAT: this.System._ParseToDecimal(TotalIncludeVAT),
          nVAT: this.System._ParseToDecimal(vat),
          nExcludeVAT: this.System._ParseToDecimal(TotalExcludeVAT)
        })
      }
    }
    this.CalculateWHT(1, byTotal);
    this.CalculateWHT(2, byTotal);
  }
  SetControlVatType(VatType) {
    //let VatType = this.InputFrom.controls['sVATType'].value;
    let Taxvat = this._VatType.filter(data => data.TAX_CODE == VatType);
    let nvat = Taxvat.map(re => re.nVAT)[0];
    if (nvat == null) {//กรณี Vat ไม่มีค่าระบบจะนำไปล็อกและตัดเป็น null
      this.InputFrom.get("nVAT").disable();
      this.InputFrom.get("nVAT").markAsUntouched({ onlySelf: true });
      this.InputFrom.controls["nVAT"].setValue(null);//Set ค่า
      this.InputFrom.controls["nVAT"].setErrors(null);//ปรับ Control ให้เป็นปกติ
      this.InputFrom.controls["nVAT"].clearValidators();//Update Validate
    }
    else { //กรณี Vat มีค่าระบบจะนำไปคำนวน
      if (this.PRMS) {
        this.InputFrom.get('nVAT').enable();
      }
      this.InputFrom.get("nVAT").markAsUntouched({ onlySelf: true });
      this.InputFrom.controls["nVAT"].setValidators(Validators.required);//กำหนด Validate
      this.InputFrom.controls["nVAT"].setErrors(null);//ปรับ Control ให้เป็นปกติ
      this.InputFrom.controls["nVAT"].updateValueAndValidity();//Update Validate
    }
  }
  CalCulateGrand() {
    let _This = this;
    let nGrandTotalAmtInvoice: any = 0.00;
    let nGrandTotalAmtVat: any = 0.00
    let nGrandTotalWithholdingTax: any = 0.00;
    let nGrandTotalAmt: any = 0.00;
    _This._ArrVendor.forEach(function (_Item) {
      if (!_Item.IsDelete && _Item.cVenderMaster == "N") {
        nGrandTotalAmt = _This.System._ParseFloatToZero(_Item.nExcludeVAT) + nGrandTotalAmt;//Grand Total Amount Excluded VAT
        nGrandTotalAmtVat = _This.System._ParseFloatToZero(_Item.nVAT) + nGrandTotalAmtVat;//Grand Total VAT
        nGrandTotalWithholdingTax = _This.System._ParseFloatToZero(_Item.nWHTVal) + _This.System._ParseFloatToZero(_Item.nWHTVal2) + nGrandTotalWithholdingTax;//Grand Total Withholding Tax
        //(Amount Excluded VAT + VAT) - WHT = Grand Total Amount Include VAT ข้อ 491 Issue
        nGrandTotalAmtInvoice = (_This.System._ParseFloatToZero(_Item.nIncludeVAT) - _This.System._ParseFloatToZero(_Item.nWHTVal) - _This.System._ParseFloatToZero(_Item.nWHTVal2)) + nGrandTotalAmtInvoice;//Grand Total Amount Include VAT
      }
    });
    this.InputFrom.patchValue({
      nGrandTotalAmtInvoice: nGrandTotalAmtInvoice,
      nGrandTotalAmtVat: nGrandTotalAmtVat,
      nGrandTotalWithholdingTax: nGrandTotalWithholdingTax,
      nGrandTotalAmt: nGrandTotalAmt
    });

    this.CalCulateClearAdvance();
  }
  CalCulateClearAdvance() {
    let _nAdvanceAmount: any = this.System._ParseFloatToZero(this.InputFrom.controls["nAdvanceAmount"].value);
    let _nCumulativeAmount: any = this.System._ParseFloatToZero(this.InputFrom.controls["nCumulativeAmount"].value);
    let _nGrandTotalAmtInvoice = this.System._ParseFloatToZero(this.InputFrom.controls["nGrandTotalAmtInvoice"].value);
    let _nPayAmount = _nAdvanceAmount - (_nCumulativeAmount + _nGrandTotalAmtInvoice);
    this.InputFrom.patchValue({
      nClearingAmount: _nGrandTotalAmtInvoice,
      nPayAmount: _nPayAmount
    });


    this.GetAdvanceText();
  }

  GetReturnFullAmount() {
    let nCumulativeAmount = this.System.ParseIntToZero(this.InputFrom.controls['nCumulativeAmount'].value);
    let nInvoiceType = this.System.ParseIntToZero(this.InputFrom.controls['nInvoiceType'].value);
    let sRefAdvanceNo = this.InputFrom.controls["sRefAdvanceNo"].value;
    if (sRefAdvanceNo) {
      if (nCumulativeAmount > 0) {
        this.IsNoReturnFull = true;
        if (nInvoiceType == 3) {
          this.InputFrom.patchValue({ nInvoiceType: 1 });
        }
      }
      else {
        this.IsNoReturnFull = false;
      }
    }
    else {
      this.IsNoReturnFull = false;
    }
  }
  GetAdvanceText() {
    this.InputFrom.controls["cRefund"].enable();
    let nInvoiceType = this.InputFrom.controls["nInvoiceType"].value;
    if (nInvoiceType == 3) {
      this.AdvanceText = "Return Full Amount";
    }
    else {
      let _nAdvanceAmount: any = this.System._ParseFloatToZero(this.InputFrom.controls["nAdvanceAmount"].value);
      let _nCumulativeAmount = this.System._ParseFloatToZero(this.InputFrom.controls["nCumulativeAmount"].value);
      let _nClearingAmount = this.System._ParseFloatToZero(this.InputFrom.controls["nClearingAmount"].value);
      let _nPayAmount = _nCumulativeAmount + _nClearingAmount;
      if (_nPayAmount > _nAdvanceAmount) {//3.1 ใช้จริง > เงินยืม = ต้องจ่ายเพิ่มให้พนักงาน
        this.AdvanceText = "Pay To Employee";
        this.InputFrom.controls["cRefund"].disable();
        this.InputFrom.controls["cRefund"].setValue("Y");
        this.InputFrom.controls["dRefund"].setValue(new Date());
      }
      else if (_nPayAmount == _nAdvanceAmount) {
        this.AdvanceText = "Net Amount";
        this.InputFrom.controls["cRefund"].disable();
        this.InputFrom.controls["dRefund"].enable();
        this.InputFrom.controls["cRefund"].setValue("Y");
        this.InputFrom.controls["dRefund"].setValue(new Date());
      }
      else if (_nPayAmount < _nAdvanceAmount) {//กรณีเป็น case ใช้จริง<เงินยืม
        this.AdvanceText = "Return to Company";
      }
    }
  }
  //#endregion

  //#region Validate
  validateAllFormFields(formGroup: FormGroup) {         //{1}
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      if (control instanceof FormControl) {             //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        //{5}
        this.validateAllFormFields(control);            //{6}
      }
    });
  }
  isFieldValid(_Field: string) {
    return !this.InputFrom.get(_Field).valid && this.InputFrom.get(_Field).touched && !this.InputFrom.get(_Field).disabled;
  }
  displayFieldCss(_Field: string) {
    return {
      'has-error': this.isFieldValid(_Field),
      'has-feedback': this.isFieldValid(_Field)
    };
  }
  isFieldValidTbGl(_Field: string, _inx) {
    let FromArray = this.InputFrom.get('ArrGL') as FormArray;
    return !FromArray.at(_inx).get(_Field).valid && FromArray.at(_inx).get(_Field).touched;
  }
  displayFieldCssTbGl(_Field: string, _inx) {
    return {
      'has-error': this.isFieldValidTbGl(_Field, _inx),
      'has-feedback': this.isFieldValidTbGl(_Field, _inx)
    };
  }
  //#endregion

  Export() {
    const link = document.createElement('a');
    link.target = '_blank'
    const httpOptions = {
      params: new HttpParams()
        .set("sReqID", this.sRequestID + "")
        .set("nContactID", this.InputFrom.get("nContactID").value),
    };
    link.href = this.System.SiteName + "api/ExportPDF/export?" + httpOptions.params
    link.setAttribute('visibility', 'hidden');
    link.click();
  }

  ReturnFullAmount_SetControl() {
    this.ClearVendor2();
    this.ClearVendorOneTime2();
    this.ClearInvoice();
    this.ClearInVoiceGL();
    //this._ArrVendor = [];
    //this._ArrVendorInvoice = [];
    this.InvoiceEdit = null;
    this.CalCulateGrand();
    this.CalCulateClearAdvance();
  }

  Check_Onetimelimit() {
    let _this = this;
    let data = this.InputFrom.get('sVendorCode2').value;
    if (data.length > 10) {
      this.swal.SwAlert.Error(this.swal.BoxMsg.Title_Error, this.swal.BoxMsg.DescOneVendorLength, function () {
        _this.InputFrom.patchValue({ sVendorCode2: "" })
      })
    }
  }
}
